<template>
  <nav class="navbar">
    <a href="#" class="sidebar-toggler" @click.prevent="$emit('toggle-sidebar')" v-if="routeMeta.layout !== 'topOnly'">
      <img :src="'/'+(`logo-${env('VUE_APP_COBRAND')}.ico` || 'favicon.ico')" height="30" />
    </a>
    <div class="navbar-content align-items-center">
      <p class="h5 font-weight-bold" v-if="routeMeta.layout !== 'topOnly'">
        {{ title }}
      </p>
      <a href="#" class="sidebar-brand" v-else>
        <img :src="'/img/'+(env('VUE_APP_COBRAND') || 'wappin')+'-logo.png'" height="30" />
      </a>
      <ul class="navbar-nav">
        <li class="nav-item" v-if="routeMeta.layout !== 'topOnly'">
          <a class="nav-link font-weight-bold" href="#" @click.prevent="selectWorkspace()">
            {{ activeWorkspace.name }}
          </a>
        </li>
        <li class="nav-item dropdown nav-profile" v-if="routeMeta.layout !== 'topOnly'">
          <a class="nav-link dropdown-toggle"
            href="#"
            id="profileDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            @click.prevent="topupHistories()"
            aria-expanded="false">
            (Rp. {{ workspaceBalance }})
          </a>
          <div class="dropdown-menu" aria-labelledby="profileDropdown">
            <div class="dropdown-body mt-2">
              <ul class="profile-nav p-0">
                <li class="nav-item mb-2">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Balance</small>
                    <el-tag size="mini" type="success">Rp. {{ workspaceBalance }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.free_credit">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free Credit</small>
                    <el-tag size="mini" type="success">Rp. {{ workspaceFreeQuota.free_credit.toLocaleString('id-ID') || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp_bi">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp BI Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp_bi || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp_ui">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp UI Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp_ui || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp_mkt">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp Marketing Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp_mkt || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp_auth">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp Authentication Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp_auth || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp_util">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp Utility Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp_util || 0 }}</el-tag>
                  </a>
                </li>
                <li class="nav-item mb-2" v-if="workspaceFreeQuota.whatsapp_svc">
                  <a href="javascript:;" class="nav-link d-flex justify-content-between w-100">
                    <small>Free WhatsApp Service Quota</small>
                    <el-tag size="mini" type="success">{{ workspaceFreeQuota.whatsapp_svc || 0 }}</el-tag>
                  </a>
                </li>
              </ul>
            </div>
            <div class="dropdown-header align-items-center">
              <a class="mb-3 w-100 btn btn-primary" @click="handlerBtnTopup">
                <font-awesome icon="money-bill-wave"/> Topup
              </a><br/>
              <a class="mb-3 w-100 btn btn-secondary" @click="$router.push({ name: 'DepositHistories' })">
                <font-awesome icon="history"/> Deposit Histories
              </a>
            </div>
            <div class="mt-2"><strong>Last Topup Histories</strong></div>
            <div class="dropdown-body mt-2" v-loading="loading.balance_histories">
              <template v-if="topup_histories_list.length > 0">
                <ul class="profile-nav p-0">
                  <li class="nav-item mb-2" v-for="item in topup_histories_list" :key="item.id">
                    <a href="javascript:;" class="nav-link d-flex justify-content-between w-100" @click="handlerBtnTopupDetail(item)">
                      <el-tag size="mini" :type="item.tag_type">{{ item.topup_amount_str }}</el-tag>
                      <small>{{ item.topup_date }}</small>
                    </a>
                  </li>
                </ul>
                <div align="center">
                  <el-button @click="$router.push({ name: 'Topup Histories', params: { workspace_id: activeWorkspace._id }})" type="text" size="small">Show all histories</el-button>
                </div>
              </template>
              <div v-else>
                <el-empty :image="lostSign" description="No topup histories."></el-empty>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="info text-center mt-1 ml-2" v-if="isUserEnableCall">
            <font-awesome icon="signal" :class="connectedRtc ? 'text-success' : 'text-danger'" size="sm"/>
          </div>
        </li>
        <li>
          <div class="info text-center mt-1 ml-2" v-if="isEnableVoIPFeature">
            <font-awesome icon="signal" :class="connectedVoip ? 'text-success' : 'text-danger'" size="sm"/>
          </div>
        </li>
        <li v-if="this.activeWorkspace._id" class="nav-item dropdown">
          <a
            class="bell-wrapper nav-link dropdown-toggle"
            href="#"
            @click="handlingOpenNotification(notificationList)"
            id="profileDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <i style="color: #39867a" class="mdi mdi-bell-outline mdi-22px"></i>
            <span
              v-if="notificationList.count_unread"
              class="badge badge-danger badge-pill notification-counter"
            >
              {{ notificationList.count_unread }}
            </span>
          </a>
          <div class="dropdown-menu dropdown-notification" aria-labelledby="profileDropdown">
            <div class="dropdown-scroll">
              <div v-if="notificationList?.rows?.length > 0">
                <template>
                  <div v-for="(notification, idx_notification_list) in notificationList.rows" :key="idx_notification_list">
                    <template v-if="notification.type === 'notifications_blogs'">
                      <li
                        @click="navigateNotification(notification)"
                        class="nav-item d-flex flex-column list-notif"
                      >
                        <p style="font-size: 14px;" class="mb-1 w-100">
                          <span style="font-weight: bold;">{{ notification.header }}</span>
                          <span
                            class="notif-description"
                            style="font-size: 13px; display: block; margin-top: 4px;"
                            v-html="truncateHtmlPreserveTags(notification.description, 100)">
                          </span>
                          <span class="d-flex mt-1">
                            <span
                            style="background-color: #e4f6f2; padding: 3px; border-radius: 6px; display: inline-block;">
                              <small style="color: #39867a">{{ notification.tags }}</small>
                            </span>
                            <div class="d-flex justify-content-center align-items-center">
                              <i style="color: gray;" class="mdi mdi-circle-small"></i>
                            </div>
                            <small class="ml-1" style="display: block; margin-top: 4px; color: gray;">
                              {{ formatRelativeTime(notification.published_at) }}
                            </small>
                          </span>
                        </p>
                      </li>
                    </template>
                    <template v-if="notification.type === 'leads'">
                      <li
                        @click="navigateNotification(notification)"
                        class="nav-item d-flex flex-column list-notif"
                      >
                      <p style="font-size: 14px;" class="mb-1 w-100">
                        <span style="font-weight: bold; display: block;">
                          <span style="color: #1868db;">{{ notification.user.name }}</span> commented on a leads
                        </span>
                        <span style="font-size: 13px; color: #1868db; display: block; margin-top: 2px;">
                          {{ notification.leads_board.name }}
                        </span>
                        <span class="d-flex mt-1">
                          <small style="display: block; margin-top: 4px; color: gray;">
                            {{ formatRelativeTime(notification.published_at) }}
                          </small>
                        </span>
                      </p>
                      </li>
                    </template>
                  </div>
                </template>
              </div>
              <el-empty v-else description="No data"></el-empty>
            </div>
            <div v-if="notificationList?.rows?.length > 0" class="dropdown-footer-bar">
              <router-link style="color: #39867a; font-weight: bold;" :to="{ name: 'Notification Blogs' }">
                Show All
              </router-link>
            </div>
          </div>
        </li>
        <li class="nav-item dropdown nav-profile ">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="profileDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            <img :src="userAvatar" alt="profile">
          </a>
          <el-badge
            v-if="isAgent"
            class="nav-link dropdown-toggle"
            id="profileDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            is-dot :type="agent_availibility_color"></el-badge>
          <div class="dropdown-menu" aria-labelledby="profileDropdown">
            <div class="dropdown-header d-flex flex-column align-items-center">
              <div class="figure mb-3">
                <img :src="userAvatar" alt="">
              </div>
              <div class="info text-center">
                <p class="name font-weight-bold mb-0">{{ userProfile.name }}</p>
                <p class="text-muted">{{ userProfile.email }}</p>
              </div>
              <div class="info text-center" v-if="isUserEnableCall || isEnableVoIPFeature">
                <p v-if="isUserEnableCall">
                  <span class="text-muted">WhatsApp Call: </span><font-awesome icon="signal" :class="connectedRtc ? 'text-success' : 'text-danger'" size="sm"/>
                </p>
                <p v-if="isEnableVoIPFeature">
                  <span class="text-muted">VoIP Call: </span><font-awesome icon="signal" :class="connectedVoip ? 'text-success' : 'text-danger'" size="sm"/>
                </p>
              </div>
            </div>
            <div class="dropdown-body">
              <ul class="profile-nav p-0 pt-3">
                 <!-- <li class="nav-item">
                  <a href="pages/general/profile.html" class="nav-link">
                    <FeatherIcon type="user" />
                    <span>Profile</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a href="javascript:;" class="nav-link">
                    <FeatherIcon type="edit" />
                    <span>Edit Profile</span>
                  </a>
                </li> -->
                <li class="nav-item" v-if="isAgent">
                  <a href="javascript:;" class="nav-link" @click="handlerBtnSetAvailibility">
                    <FeatherIcon type="power" />
                    Set Availibility
                  </a>
                </li>
                <li class="nav-item">
                  <a href="javascript:;" class="nav-link" @click="showModal = true;">
                    <FeatherIcon type="lock" />
                    <span>Change password</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a href="javascript:;" class="nav-link" @click="doShowModalCompanyProfile">
                    <font-awesome :icon="['far', 'building']"/>
                    <span>Company Profile</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a href="javascript:;" class="nav-link" @click="doShowModalAccountProfile">
                    <FeatherIcon type="users" />
                    <span>Account Profile</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a href="javascript:;" class="nav-link" @click.prevent="doLogout()">
                    <FeatherIcon type="log-out" />
                    <span>Log Out</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <!-- v-if="routeMeta.layout !== 'topOnly' && this.call_session?.session" -->
    <preview-minimize-call
      :show="showModalMinimizeCall"
      :call_session="call_session"
      :phone_call="phone_call"
      :call="call"
      @onHide="showModalMinimizeCall = false"
      @handleMicPhoneCall="handleMicPhoneCall"
      @handleCamPhoneCall="handleCamPhoneCall"
    />
    <preview-minimize-video-call
      ref="prevMinCall"
      :call_session="call_session"
      :show="showModalMinimizeCall"
      @onHide="showModalMinimizeCall = false"
    />
    <preview-maximize-call
      ref="prevMaxCall"
      :show="showModalMaximizeCall"
      :call_session="call_session"
      :phone_call="phone_call"
      :call="call"
      @onHide="showModalMaximizeCall = false"
      :notes="notes"
      @update:notes="notes = $event"
      @handleMicPhoneCall="handleMicPhoneCall"
      @handleCamPhoneCall="handleCamPhoneCall"
    />
    <audio class="hidden" id="audio" ref="audio" autoplay controls></audio>
    <!-- <preview-incoming-call
      :show="showModalIncomingCall"
      :call_session="call_session"
      @onHide="showModalIncomingCall = false"
    /> -->
    <b-modal v-model="showModal" title="Change Password" hide-footer>
      <b-form @submit.prevent="changePassword" @reset="closeModal">
        <b-form-group id="ig-oldpassword" label="Old password:" label-for="i-passwordl">
          <el-input show-password id="i-oldpassword" type="password" placeholder="Input your old password" required v-model="v$.form.old_password.$model" />
          <b-form-invalid-feedback :state="!v$.form.old_password.$invalid" v-if="v$.form.old_password.$errors[0]">
            {{ v$.form.old_password.$errors[0].$message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-newpassword" label="New password:" label-for="i-passwordl">
          <el-input show-password id="i-newpassword" type="password" placeholder="Input your new password" required v-model="v$.form.new_password.$model" />
          <b-form-invalid-feedback :state="!v$.form.new_password.$invalid" v-if="v$.form.new_password.$errors[0]">
            {{ v$.form.new_password.$errors[0].$message }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="ig-confirmpassword" label="Re-type new password:" label-for="i-passwordl">
          <el-input show-password id="i-confirmpassword" type="password" placeholder="Re-type your new password" required v-model="v$.form.confirm_password.$model" />
          <b-form-invalid-feedback :state="!v$.form.confirm_password.$invalid" v-if="v$.form.confirm_password.$errors[0]">
            {{ v$.form.confirm_password.$errors[0].$message }}
          </b-form-invalid-feedback>
        </b-form-group>

        <div class="d-flex flex-row-reverse">
          <el-button native-type="submit" :loading="loading.change_password" size="small" class="ml-2 btn-primary font-weight-bold">{{ $t('general.submit') }}</el-button>
          <el-button native-type="reset" size="small" class="btn-secondary font-weight-bold" >{{ $t('general.cancel') }}</el-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal v-model="showModalCompanyProfile" title="Company Profile" hide-footer>
      <b-form @submit.prevent="updateCompanyProfile" @reset="closeModalCompanyProfile">
        <b-form-group label="Company Name">
          <b-form-input
            v-model="v$.company_form.name.$model"
            placeholder="Your company name">
          </b-form-input>
          <b-form-invalid-feedback :state="!v$.company_form.name.$invalid" v-if="v$.company_form.name.$errors[0]">
            {{ $t('validation.' + v$.company_form.name.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Company Brand">
          <b-form-input
            v-model="v$.company_form.brand_name.$model"
            placeholder="Your company brand">
          </b-form-input>
          <b-form-invalid-feedback :state="!v$.company_form.brand_name.$invalid" v-if="v$.company_form.brand_name.$errors[0]">
            {{ $t('validation.' + v$.company_form.brand_name.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Company Address">
          <b-form-textarea
            v-model="v$.company_form.address.$model"
            rows="3"
            placeholder="Your company address">
          </b-form-textarea>
          <b-form-invalid-feedback :state="!v$.company_form.address.$invalid" v-if="v$.company_form.address.$errors[0]">
            {{ $t('validation.' + v$.company_form.address.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Business Entities">
          <el-select class="w-100" v-model="v$.company_form.business_entity_id.$model" placeholder="Select your business entities">
            <el-option v-for="item in business_entities" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
          <b-form-invalid-feedback :state="!v$.company_form.business_entity_id.$invalid" v-if="v$.company_form.business_entity_id.$errors[0]">
            {{ $t('validation.' + v$.company_form.business_entity_id.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Business Type">
          <el-select filterable class="w-100" v-model="v$.company_form.business_type_id.$model" placeholder="Select your business type">
            <el-option v-for="item in business_types" :key="item.id" :label="item.name" :value="item.id"/>
          </el-select>
          <b-form-invalid-feedback :state="!v$.company_form.business_type_id.$invalid" v-if="v$.company_form.business_type_id.$errors[0]">
            {{ $t('validation.' + v$.company_form.business_type_id.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Company Logo">
          <img
            :src="this.companyProfile.logo_src ? this.companyProfile.logo_src : 'https://static.vecteezy.com/system/resources/previews/005/337/799/original/icon-image-not-found-free-vector.jpg'"
            style="object-fit: contain; width: 30%; height: 25%;" />

          <b-form-file
            accept=".jpeg, .jpg, .png"
            placeholder="Choose a file or drop it here."
            drop-placeholder="Drop file here."
            v-model="company_form.file"
            @change="v$.company_form.file.$touch()"
          ></b-form-file>
          <b-form-invalid-feedback :state="!v$.company_form.file.$invalid"  v-if="v$.company_form.file.$error">
            File image maximum 5MB.
          </b-form-invalid-feedback>
          <el-progress v-if="loading.upload_file" :percentage="upload_progress" :status="upload_status"></el-progress>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <el-button native-type="submit" :loading="loading.update_compro" size="small" class="ml-2 btn-primary font-weight-bold">{{ $t('general.submit') }}</el-button>
          <el-button native-type="reset" size="small" class="btn-secondary font-weight-bold" >{{ $t('general.cancel') }}</el-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal v-model="showModalAccountProfile" title="Account Profile" hide-footer>
      <b-form @submit.prevent="updateAccountProfile" @reset="closeModalAccountProfile">
        <b-form-group label="Name">
          <b-form-input
            v-model="v$.account_form.name.$model"
            placeholder="Enter your name">
          </b-form-input>
          <b-form-invalid-feedback :state="!v$.account_form.name.$invalid" v-if="v$.account_form.name.$errors[0]">
            {{ $t('validation.' + v$.account_form.name.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Email">
          <b-form-input
            v-model="v$.account_form.email.$model"
            placeholder="Enter your email">
          </b-form-input>
          <b-form-invalid-feedback :state="!v$.account_form.email.$invalid" v-if="v$.account_form.email.$errors[0]">
            {{ $t('validation.' + v$.account_form.email.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Phone Number">
          <b-form-input
            v-model="v$.account_form.phone_number.$model"
            placeholder="Enter your phone number">
          </b-form-input>
          <b-form-invalid-feedback :state="!v$.account_form.phone_number.$invalid" v-if="v$.account_form.phone_number.$errors[0]">
            {{ $t('validation.' + v$.account_form.phone_number.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Password">
          <b-form-input
            placeholder="Enter your password"
            autocomplete="one-time-code"
            type="password"
            v-model="account_form.password" />
          <b-form-invalid-feedback :state="!v$.account_form.password.$invalid" v-if="v$.account_form.password.$errors[0]">
            {{ $t('validation.' + v$.account_form.password.$errors[0].$validator) }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Photo Profile">
          <img
            :src="this.accountProfile.profile_src ? this.accountProfile.profile_src : 'https://static.vecteezy.com/system/resources/previews/005/337/799/original/icon-image-not-found-free-vector.jpg'"
            style="object-fit: contain; width: 30%; height: 25%;" />

          <b-form-file
            accept=".jpeg, .jpg, .png"
            placeholder="Choose a file or drop it here."
            drop-placeholder="Drop file here."
            v-model="account_form.file"
            @change="v$.account_form.file.$touch()"
          ></b-form-file>
          <b-form-invalid-feedback :state="!v$.account_form.file.$invalid"  v-if="v$.account_form.file.$error">
            File image maximum 5MB.
          </b-form-invalid-feedback>
          <el-progress v-if="loading.upload_file" :percentage="upload_progress" :status="upload_status"></el-progress>
        </b-form-group>
        <div class="d-flex flex-row-reverse">
          <el-button native-type="submit" :loading="loading.update_accpro" size="small" class="ml-2 btn-primary font-weight-bold">{{ $t('general.submit') }}</el-button>
          <el-button native-type="reset" size="small" class="btn-secondary font-weight-bold" >{{ $t('general.cancel') }}</el-button>
        </div>
      </b-form>
    </b-modal>
    <b-modal size="lg" v-model="showModalTopup" title="Balance Topup" hide-footer @hide="onHideTopup">
      <el-steps :active="current_step" finish-status="success" simple="">
        <el-step title="Fill Data" icon="el-icon-warning-outline"></el-step>
        <el-step title="Confirmation" icon="el-icon-s-claim"></el-step>
        <el-step title="Payment Detail" icon="el-icon-postcard"></el-step>
      </el-steps>
      <template v-if="current_step == 0">
        <b-form>
          <b-form-group label="Topup Amount">
            <el-radio-group @change="handlerChangeAmountBtn" v-model="form1.topup_amount" class="w-100">
              <el-radio-button v-for="(item, index) in amount_opt" :key="index" :value="item.value" :label="item.text"></el-radio-button>
            </el-radio-group>
            <el-input placeholder="Please input topup amount" v-model="form1.amount" class="mt-2">
              <template slot="prepend">Rp</template>
            </el-input>
            <b-form-invalid-feedback :state="!v$.form1.amount.$invalid" v-if="v$.form1.amount.$error">
            {{ v$.form1.amount.$errors[0].$message }}
          </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Payment Method">
            <el-select v-model="form1.payment_method_id" placeholder="Please choose payment method" class="w-100">
              <el-option v-for="item in sof" :key="item.id" :value="item.id" :label="item.name"></el-option>
            </el-select>
            <b-form-invalid-feedback :state="!v$.form1.payment_method_id.$invalid" v-if="v$.form1.payment_method_id.$error">
            {{ $t('validation.' + v$.form1.payment_method_id.$errors[0].$validator) }}</b-form-invalid-feedback>
          </b-form-group>
          <div class="d-flex flex-row float-right mt-2">
          <el-button @click="handlerBtnNextTopup" class="mr-2 ml-2" size="small" type="primary">Next</el-button>
          <el-button @click="showModalTopup = false" size="small" class="mr-2">Cancel</el-button>
        </div>
        </b-form>
      </template>
      <template v-if="current_step == 1">
        <el-descriptions class="mt-2" title="Topup Information" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-money"></i>
              Topup Amount
            </template>
            {{ confirmation_detail.topup_amount }}
          </el-descriptions-item>
          <el-descriptions-item v-if="confirmation_detail.ppn_amount">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              VAT 11%
            </template>
            {{ confirmation_detail.ppn_amount }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-bank-card"></i>
              Payment Method
            </template>
            {{ confirmation_detail.payment_method }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="user"/>
              Admin Fee
            </template>
            {{ confirmation_detail.admin_fee }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="money-bill-wave"/>
              Total Payment
            </template>
            {{ confirmation_detail.total_transfer }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="d-flex flex-row float-left mt-2">
          <el-button @click="current_step -= 1" type="info" size="small" class="mr-2">Back</el-button>
        </div>
        <div class="d-flex flex-row float-right mt-2">
          <el-button @click="handlerBtnNextTopup" class="mr-2 ml-2" size="small" type="primary">Next</el-button>
          <el-button @click="showModalTopup = false" size="small" class="mr-2">Cancel</el-button>
        </div>
      </template>
      <template v-if="current_step == 2">
        <p class="mt-2 mb-2">Please transfer to this following detail. You should pay before <strong class="text-red">{{ resp.expired_at_str }}</strong></p>
        <el-descriptions class="margin-top" title="" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              <!-- <font-awesome icon="money-bill-wave"/> -->
              <i class="el-icon-document"></i>
              Invoice Number
            </template>
            {{ resp.invoice_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-money"></i>
              Topup Amount
            </template>
            {{ confirmation_detail.topup_amount }}
          </el-descriptions-item>
          <el-descriptions-item v-if="confirmation_detail.ppn_amount">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              VAT 11%
            </template>
            {{ confirmation_detail.ppn_amount }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="user"/>
              Admin Fee
            </template>
            {{ confirmation_detail.admin_fee }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="money-bill-wave"/>
              Total Payment
            </template>
            {{ confirmation_detail.total_transfer }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-bank-card"></i>
              Payment Method
            </template>
            {{ confirmation_detail.payment_method }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="user"/>
              Virtual Account Number
            </template>
            {{ resp.virtual_account_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="calendar"/>
              Expired Date
            </template>
            {{ resp.expired_at_str }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="mt-3 mb-3"><strong>How to Topup</strong></div>
        <el-collapse v-model="active_collapse_howtopay" accordion>
          <el-collapse-item v-for="(item, index) in resp.how_to_pay" :key="index" :title="item.channel" :name="index">
            <ol>
              <li v-for="(step, i) in item.step" :key="i">{{ step }}</li>
            </ol>
          </el-collapse-item>
        </el-collapse>
        <div class="d-flex flex-row float-right mt-2">
          <el-button v-if="!is_waiting_payment" @click="handlerBtnNextTopup" class="mr-2 ml-2" size="small" type="primary">Done</el-button>
          <el-button v-else @click="handlerBtnCancelRequest" class="mr-2 ml-2" size="small" type="primary">Cancel Request</el-button>
          <el-button @click="showModalTopup = false" size="small" class="mr-2">Close</el-button>
        </div>
      </template>
    </b-modal>
    <b-modal size="lg" v-model="showModalTopupDetail" title="Topup Request" hide-footer @hide="onHideTopup">
      <el-descriptions class="margin-top" title="" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              <!-- <font-awesome icon="money-bill-wave"/> -->
              <i class="el-icon-document"></i>
              Invoice Number
            </template>
            {{ topup_history_detail.invoice_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-money"></i>
              Topup Amount
            </template>
            {{ topup_history_detail.topup_amount_str }}
          </el-descriptions-item>
          <el-descriptions-item v-if="topup_history_detail.ppn_amount">
            <template slot="label">
              <i class="el-icon-tickets"></i>
              VAT 11%
            </template>
            {{ topup_history_detail.ppn_amount_str }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="user"/>
              Admin Fee
            </template>
            {{ topup_history_detail.admin_fee_str }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="money-bill-wave"/>
              Total Payment
            </template>
            {{ topup_history_detail.total_transaction_str }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <i class="el-icon-bank-card"></i>
              Payment Method
            </template>
            {{ topup_history_detail.payment_method_str }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="barcode"/>
              Virtual Account Number
            </template>
            {{ topup_history_detail.virtual_account_number }}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <font-awesome icon="money-check"/>
              Payment Status
            </template>
            <el-tag size="small" :type="topup_history_detail.tag_type">{{ topup_history_detail.status_str }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item v-if="topup_history_detail.creator">
            <template slot="label">
              <!-- <font-awesome icon="money-check"/> -->
              <i class="el-icon-s-custom"></i>
              Request By
            </template>
            {{ topup_history_detail.creator.name }}
          </el-descriptions-item>
          <el-descriptions-item v-if="topup_history_detail.status !== 'paid'">
            <template slot="label">
              <font-awesome icon="calendar"/>
              Expired Date
            </template>
            {{ topup_history_detail.expired_at_str }}
          </el-descriptions-item>
          <el-descriptions-item v-if="topup_history_detail.status === 'paid'">
            <template slot="label">
              <font-awesome icon="calendar"/>
              Paid Date
            </template>
            {{ topup_history_detail.paid_at_str }}
          </el-descriptions-item>
      </el-descriptions>
      <div class="flex justify-between-content mt-2">
        <a :href="topup_history_detail.topup_receipt_url" class="text-normal" target="_blank">
          <font-awesome icon="file-pdf"/>&nbsp;Download Invoice
        </a>
        <el-button @click="showModalTopupDetail = false" size="small" class="float-right">Close</el-button>
      </div>
    </b-modal>
    <b-modal content-class="shadow-lg bg-dark text-light border-dark p-2" size="lg" v-model="notes.showModalNotes" title="Notes Call" hide-header hide-footer>
      <h4 class="mb-3">Notes Call</h4>
        <div class="w-100">
          <textarea
            id="notes"
            v-model="notes.content"
            :maxlength="notes.maximumLength"
            rows="11"
            class="w-100 p-2 rounded text-light bg-dark"
            style="border: 1px solid rgba(255, 255, 255, 0.15);"
            placeholder="Write notes about this call here..."
          ></textarea>
          <div class="text-right text-secondary mt-1 text-sm">
            {{ notes.content.length }} / {{ notes.maximumLength }}
          </div>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <el-button class="btn btn-outline-primary" size="small" @click="notes.showModalNotes = false">Close</el-button>
          <el-button @click="saveNotes" type="primary" size="small">Save</el-button>
        </div>
      </div>
    </b-modal>

    <div
    v-if="dialNumpad.showModalNumpad"
    class="position-fixed p-4 border rounded-lg shadow-sm container-dialnumpad highlight_green_white"
    >
    <div v-if="!dialNumpad.highlight">
      <div class="mb-4 text-center">
        <p class="mb-2 pg_header_phone_number">Enter phone number</p>
        <p class="pg_header_dial_number">Dial a number to start the call</p>
      </div>
      <div class="d-flex align-items-center justify-content-center w-100 text-center mt-3 mb-4">
        <input class="box_number_numpad" v-model="dialNumpad.value" @input="onInputNumpad" @paste="onPasteNumpad" type="text" />
      </div>

      <div class="mt-3">
        <div class="d-flex flex-wrap justify-content-center keypad_numpad">
          <el-button
            v-for="(item, index) in dialNumpad.keys"
            :key="index"
            class="keypad-btn"
            @click="handleDial(item)"
          >
            {{ item }}
          </el-button>
          <div class="w-100 d-flex justify-content-center align-items-center">
            <div class="d-flex justify-content-end w-100 mt-3 gap-3 flex-wrap">
              <el-button
                @click="handleCall()"
                class="call-btn mr-2"
                type="primary"
                :disabled="dialNumpad.value === '' ? true : false"
              >
                <span class="mdi mdi-phone"></span>
              </el-button>
              <el-button
                class="backspace-btn mr-3"
                @click="handleDial('remove')"
              >
                <span class="mdi mdi-backspace backspace_numpad"></span>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <el-button
      v-if="isEnableVoIPFeature"
      @mouseover.native="dialNumpad.hover = true"
      @mouseleave.native="dialNumpad.hover = false"
      :style="dialNumpad.hover && 'transition: all 1s ease, transform 0.3s ease; box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); transform: scale(1.05);'"
      @click="showNumpad"
      class="btn_numpad btn btn-success position-fixed rounded-left bg-primary"
    >
      <div class="d-flex justify-content-center">
        <span class="icon_numpad mdi mdi-dialpad"></span>
        <p v-if="dialNumpad.hover" class="pg_numpad ml-1">Keypad</p>
      </div>
    </el-button>
  </nav>
</template>

<style>
.mdi-bell {
  display: inline-block !important;
}

.dropdown-notification {
  white-space: normal;
  max-width: 400px !important;
}

.list-notif {
  width: 100%;
  padding: 14px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  white-space: normal;
  word-break: break-word;
}

.notif-description,
.notif-description * {
  text-align: left !important;
}

.list-notif:hover {
  background-color: #f1f1f2;
}

.nav-item.dropdown {
  position: relative;
}

.list-notif img, .list-notif video {
  max-width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: contain;
  display: block;
}

.notif-description {
  text-align: left !important;
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

.bell-wrapper {
  position: relative;
  display: inline-block;
}

.notification-counter {
  position: absolute;
  top: -4px;
  right: -8px;
  font-size: 0.6rem;
  min-width: 14px;
  height: 14px;
  line-height: 12px;
  text-align: center;
  border-radius: 50%;
  padding: 1px;
}

.dropdown-scroll {
  width: 350px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dropdown-footer-bar {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 8px 12px;
  text-align: center;
}

.dropdown-scroll li p {
  margin: 0;
}

.container-dialnumpad {
  right: 20px;
  width: 100%;
  max-width: 400px;
  height: auto;
  display: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  bottom: 110px;
  right: 20px;
  z-index: 1;
}

.btn_numpad {
  bottom: 50px;
  right: 0px;
  z-index: 1;
}

.box_number_numpad {
  background-color: white !important;
  border: none !important;
  border-bottom: 2px solid #118c7f !important;
  font-size: 32px;
  text-align: center !important;
  overflow-x: auto;
  white-space: nowrap;
  outline: none !important;
  pointer-events: auto;
  width: 100%;
}

.box_number_numpad:focus {
  outline: none !important;
  box-shadow: none !important;
}

.keypad-btn {
  width: 60;
  height: 50px;
  margin: 8px;
  background-color: #FBFBFB;
  font-size: 28px;
  border: none;
  text-align: center;
}

.call-btn {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: white;
  font-size: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.backspace-btn {
  width: 60px;
  height: 60px;
  background-color: white !important;
  font-size: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
}

.backspace_numpad {
  color: #118c7f;
}

.pg_header_phone_number {
  font-size: 24px;
  font-weight: bold;
}

.pg_header_dial_number {
  font-size: 16px;
}

.icon_numpad {
  font-size: 24px;
}

.pg_numpad {
  font-size: 16px;
}

.highlight_green_white {
  animation: flash-green-white 1s ease forwards;
}

@keyframes flash-green-white {
  0% { background-color: #118c7f; }
  100% { background-color: white; }
}

@media (min-width: 768px) {
  .container-dialnumpad {
    width: 300px;
    height: 557px;
  }
}

@media (max-width: 480px) {
  .keypad-btn {
    width: 55px;
    height: 50px;
    font-size: 22px;
  }

  .call-btn,
  .backspace-btn {
    width: 60px;
    height: 60px;
  }

  .pg_header_phone_number {
    font-size: 20px;
  }

  .pg_header_dial_number {
    font-size: 14px;
  }

  .box_number_numpad {
    font-size: 24px;
  }
}
</style>

<script>
import lostSign from '@/assets/images/undraw/lost-sign.svg';
import moment from 'moment';
// import JsSIP from 'jssip';
import { clone, isEmpty } from 'lodash';
import useVuelidate from '@vuelidate/core';
import {
  required, numeric, minValue, sameAs, helpers, minLength, email, maxLength,
} from '@vuelidate/validators';
import config from '@/config';
import openSocket from 'socket.io-client';
import cookie from '../../library/cookie';

import avatar from '../../library/avatar';
import authApi from '../../api/auth';
import profileApi from '../../api/profile';
import workspaceApi from '../../api/workspaces';
import conversationsAPI from '../../api/conversations';
import popupErrorMessages from '../../library/popup-error-messages';
import topupApi from '../../api/topup';
import agents from '../../api/agents';
import blogNotifApi from '../../api/blogNotif';
// import store from '../../store';
import passwordComplexity from '../../library/password-complexity';
import PreviewMinimizeCall from './conversations/PreviewMinimizeCall.vue';
import PreviewMinimizeVideoCall from './conversations/PreviewMinimizeVideoCall.vue';
// import PreviewIncomingCall from './conversations/PreviewIncomingCall.vue';
import PreviewMaximizeCall from './conversations/PreviewMaximizeCall.vue';
import RingtoneSound from '../../assets/sound/Ringtone_1.mp3';
import CallWaitingSound from '../../assets/sound/CallWaiting_1.mp3';
// import PreviewPhoneCall from './conversations/PreviewPhoneCall.vue';
import NotifIncomingCall from '../../assets/sound/notif-call-waiting.mp3';

// const connect_sip = new JsSIP.WebSocketInterface('wss://process.env.VUE_APP_SIP_DOMAIN:8089/ws');
// const configuration = {
//   sockets: [connect_sip],
//   uri: `sip:${store.state.auth.extensions}@process.env.VUE_APP_SIP_DOMAIN`,
//   password: 'WAPPIN2024',
//   display_name: store.state.auth.userProfile.name,
// };
// const socket_sip = new JsSIP.UA(configuration);
const socket_call = openSocket(config.api.chatUrl, {
  transports: ['websocket'],
  upgrade: false,
  reconnection: true,
  reconnectionAttempts: 1000,
  reconnectionDelay: 1000,
});

const ui_call_socket = {
  button_call_color: 'text-secondary',
  button_call_active: false,
  contact_call_color: 'outline-secondary',
};
export { ui_call_socket };

export default {
  name: 'Navbar',
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    PreviewMaximizeCall,
    PreviewMinimizeCall,
    PreviewMinimizeVideoCall,
    // PreviewIncomingCall,
  },
  metaInfo() {
    return {
      titleTemplate: (s) => {
        this.title = s;
        return (s ? `${s} | Kanca` : 'Kanca');
      },
    };
  },
  data() {
    return {
      reconnect: false,
      ui_call_socket,
      call_details: {},
      call_session: {},
      call: {
        duration: 0,
        startTime: '',
        talktime: 0,
        startCall: '',
      },
      phone_call: {
        status: 'Calling...',
        mic: 'mdi mdi-microphone mdi-22px',
        video: 'mdi mdi-video-off mdi-22px',
        volume: 'mdi mdi-volume-low mdi-22px',
        name: '',
        channel: '',
        phone_number: '',
        conversation_id: '',
        workspace_id: '',
        msg_id: '',
        id: '',
      },
      audio_ringtone: new Audio(RingtoneSound),
      audio_ringing: new Audio(CallWaitingSound),
      offerOptions: {
        offerToReceiveAudio: 1,
        offerToReceiveVideo: 0,
      },
      showModalIncomingCall: false,
      showModalMinimizeCall: false,
      showModalMaximizeCall: false,
      isPhoneMuted: false,
      isOffCam: true,
      lostSign,
      title: '',
      showModal: false,
      showModalCompanyProfile: false,
      form: {
        old_password: '',
        new_password: '',
        confirm_password: '',
      },
      showModalAccountProfile: false,
      upload_status: '',
      upload_progress: '',
      loading: {
        change_password: false,
        update_compro: false,
        update_accpro: false,
        balance_histories: false,
        upload_file: false,
        phone_call: false,
      },
      company_form: {
        name: '',
        brand_name: '',
        address: '',
        business_type_id: '',
        business_entity_id: '',
      },
      account_form: {
        name: '',
        email: '',
        phone_number: '',
        password: '',
        file: [],
      },
      active_collapse_howtopay: '',
      business_entities: [],
      business_types: [],
      companyProfile: {},
      notificationList: [],
      accountProfile: {},
      loader: null,
      loaderStack: 0,
      showModalTopup: false,
      showModalTopupDetail: false,
      current_step: 0,
      form1: {
        topup_amount: '',
        amount: null,
        payment_method_id: null,
      },
      confirmation_detail: {},
      amount_opt: [
        {
          value: 50000,
          text: 'Rp 50.000',
        },
        {
          value: 100000,
          text: 'Rp 100.000',
        },
        {
          value: 200000,
          text: 'Rp 200.000',
        },
        {
          value: 500000,
          text: 'Rp 500.000',
        },
      ],
      sof: [],
      resp: {
        how_to_pay: [],
      },
      topup_histories_list: [],
      is_waiting_payment: false,
      topup_history_detail: {},
      calculate_topup_result: {},
      agent_availibility_color: 'danger',
      is_agent_availibility: false,
      call_message_data: {
        msg_id: '',
      },
      pc: null,
      localIceCandidates: new Set(),
      localStream: null,
      remoteStream: new MediaStream(),
      sdp_offer: null,
      sdpOffer: '',
      isConnecting: false,
      socket: null,
      call_direction: '',
      conversation: null,
      // for record local
      mediaRecorder: null,
      audioChunks: [],
      current_call_id: null,
      soundIncomingCall: [],
      successPingCall: [],
      connectedVoip: false,
      connectedRtc: false,
      dialNumpad: {
        value: '',
        showModalNumpad: false,
        keys: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'],
        hover: false,
        highlight: false,
      },
      selectedContact: null,
      notes: {
        showModalNotes: false,
        content: '',
        maximumLength: 4096,
        msg_id: '',
      },
      kAllowedAudioCodecs: ['audio/opus', 'audio/telephone-event'],
      videoCodecs: [
        {
          mimeType: 'video/H264',
          sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42001f',
          MapTo: 97,
        },
      ],
      animationFrameId: null,
      isDrawing: false,
    };
  },
  validations() {
    return {
      company_form: {
        name: { required },
        brand_name: { required },
        address: { required },
        business_type_id: { required },
        business_entity_id: { required },
        file: {
          maxFileSize: (value) => {
            if (!value) return true;
            const limit = 5 * 1024 * 1024; // 5MB
            return value.size <= limit;
          },
        },
      },
      account_form: {
        name: {
          required,
        },
        email: {
          required,
          email,
        },
        phone_number: {
          required,
          numeric,
          minLength: minLength(9),
          maxLength: maxLength(15),
        },
        password: {
          minLength: minLength(8),
        },
        file: {
          maxFileSize: (value) => {
            if (!value) return true;
            const limit = 5 * 1024 * 1024; // 5MB
            return value.size <= limit;
          },
        },
      },
      form1: {
        amount: {
          required,
          numeric,
          minValue: minValue(10000),
        },
        payment_method_id: { required },
      },
      form: {
        old_password: {
          required,
        },
        new_password: {
          required,
          minLength: minLength(8),
          complexity: helpers.withMessage(() => 'Password should have at least 1 uppercase, 1 lowercase, 1 number and 1 special character', passwordComplexity),
        },
        confirm_password: {
          required,
          sameAs: sameAs(this.form.new_password, 'new password'),
          minLength: minLength(8),
          complexity: helpers.withMessage(() => 'Password should have at least 1 uppercase, 1 lowercase, 1 number and 1 special character', passwordComplexity),
        },
      },
      onSetConnected: false,
    };
  },
  beforeDestroy() {
    this.reconnect = false;
    socket_call.disconnect();
  },
  async mounted() {
    this.checkWorkspaceBalance();
    this.agent_availibility_color = this.userProfile.agents[0]?.is_available ? 'success' : 'danger';
    this.checkAvailibility();
    this.loadNotificationNews();
    // socket sip for call
    if (this.isEnableVoIPFeature === true && this.userProfile.agents[0] && this.SIPsocket) {
      const agent_data = this.userProfile.agents[0];
      if (agent_data.assigned_call_feature === true && agent_data.is_available === true && this.ui_call_socket.button_call_active === false) {
        this.SIPsocket.start();
      } else if (this.ui_call_socket.button_call_active === true) {
        if (this.phone_call.msg_id) {
          this.SIPsocket.terminateSessions();
        }
        this.SIPsocket.stop();
      }
      this.SIPsocket.on('connected', () => {
        this.check_socket_sip('1');
        console.log('connect socket sip navbar');
        // if (agent_data.assigned_call_feature === true && agent_data.is_available === true) {
        //   this.SIPsocket.stop();
        //   console.log('redisconnect socket sip navbar');
        // }
      });
      this.SIPsocket.on('disconnected', () => {
        this.check_socket_sip('0');
        if (this.phone_call.msg_id) {
          this.SIPsocket.terminateSessions();
          this.soundIncomingCall.forEach((item) => {
            item.audio.pause();
            item.audio.currentTime = 0;
          });
        }
        this.ui_call_socket.button_call_active = false;
        console.log('disconnected socket sip navbar');
        // if (agent_data.assigned_call_feature === true && agent_data.is_available === true) {
        //   this.SIPsocket.start();
        //   console.log('reconnect socket sip navbar');
        // }
      });
      this.SIPsocket.on('newRTCSession', async (e) => {
        console.log('rtc - session created');
        this.call_session = e;
        this.pc = e.session.connection;
        this.remoteStream = new MediaStream();
        if (this.call_session.session.direction === 'incoming') {
          this.soundIncomingCall = [];

          const devices = await navigator.mediaDevices.enumerateDevices();
          const audioSpeakersDevices = devices.filter((u) => u.kind === 'audiooutput');
          audioSpeakersDevices.map((device) => (
            this.soundIncomingCall.push({
              audio: new Audio(NotifIncomingCall),
              deviceId: device.deviceId,
              label: device.label,
            })
          ));
          this.soundIncomingCall.map(async (sound) => {
            await sound.audio.setSinkId(sound.deviceId);
            sound.audio.loop = true;
            sound.audio.volume = 0.7;
          });

          if (!(this.isEnableVoIPFeature === true && this.userProfile.agents[0] && this.SIPsocket)) {
            console.log('incoming call has to stop');
            this.SIPsocket.stop();
          } else {
            this.call.startCall = moment.utc();
            console.log(' incoming session');
            if (!this.onSetConnected) {
              this.onSetConnected = true;
              this.setConnectedCall();
            }
          }
        } else {
          console.log(' outgoing session');
          this.phone_call = {
            status: 'Calling...',
            mic: 'mdi mdi-microphone mdi-22px',
            volume: 'mdi mdi-volume-low mdi-22px',
            video: 'mdi mdi-video-off mdi-22px',
            name: '',
            channel: 'Mobile Phone',
            phone_number: '',
            conversation_id: '',
            workspace_id: '',
            msg_id: '',
            id: '',
          };
          let selected_contact = this.call_session.session.data.conversation.contacts.find((v) => v.channel === 'whatsapp');
          if (!selected_contact) {
            selected_contact = this.call_session.session.data.conversation.contacts.find((v) => v.channel === 'phone_call');
          }
          this.phone_call.name = selected_contact.name || selected_contact.display_name;
          this.phone_call.phone_number = selected_contact.phone_number;
          this.phone_call.status = 'Calling...';
          this.phone_call.conversation_id = this.call_session.session.data.conversation?.id;
          if (this.phone_call.conversation_id) {
            const form_data = {
              call_id: this.call_session.session.id,
              phone_number: this.phone_call.phone_number,
              workspace_id: this.activeWorkspace._id,
              conversation_id: this.phone_call.conversation_id,
            };
            await conversationsAPI.outgoingConvoCall(form_data)
              .then(async (response) => {
                await popupErrorMessages(response);
                this.phone_call.msg_id = response.data.msg.id;
                this.phone_call.id = response.data.calls.id;
                this.notes.msg_id = response.data.msg.id;
                this.phone_call.workspace_id = clone(this.activeWorkspace._id);
                this.showModalMinimizeCall = true;
              }).catch((err) => {
                console.log(err);
                this.endCall({
                  status: 'failed',
                  cause: 'conversation call failed',
                });
                // this.handleEndPhoneCall();
              });
          } else {
            const form_data = {
              workspace_id: this.activeWorkspace._id,
              contact_id: selected_contact.id,
              call_id: this.call_session.session.id,
            };
            await conversationsAPI.outgoingContactCall(form_data)
              .then(async (response) => {
                await popupErrorMessages(response);
                this.call_session.session.data.conversation.id = response.data.convo.id;
                this.phone_call.conversation_id = response.data.convo.id;
                this.phone_call.msg_id = response.data.msg.id;
                this.phone_call.id = response.data.calls.id;
                this.notes.msg_id = response.data.msg.id;
                this.phone_call.workspace_id = clone(this.activeWorkspace._id);
                this.showModalMinimizeCall = true;
              }).catch((err) => {
                console.log(err);
                this.endCall({
                  status: 'failed',
                  cause: 'contact call failed',
                });
                // this.handleEndPhoneCall();
              });
          }
          this.pc.ontrack = (event) => {
            console.log('WebRTC: Event ontrack: Received remote streams %d. Hooking up track ID: %s', event.streams.length, event.streams[0].id);
            const audio = document.querySelector('audio#audio');
            audio.srcObject = event.streams[0];
            event.streams[0].getTracks().forEach((track) => {
              if (track) {
                this.remoteStream.addTrack(track); // Add each track to the remote stream
              }
            });
          };
        }
        this.call_session.session.on('progress', (pg) => {
          console.log('rtc - progress');
          console.log(pg);
          console.log(this.call_session.session.direction);
          if (this.call_session.session.direction === 'outgoing') {
            this.phone_call.status = 'Ringing...';
            this.call.startCall = moment.utc();
            this.setConnectedCall();
          }
        });
        this.call_session.session.on('accepted', (ac) => {
          console.log('rtc - accepted');
          console.log(ac);
          this.phone_call.status = 'Connecting...';
          if (this.call_session.session.direction === 'incoming') {
            this.soundIncomingCall.forEach((item) => {
              item.audio.pause();
              item.audio.currentTime = 0;
            });
          }
        });
        this.call_session.session.on('confirmed', (cf) => {
          console.log('rtc - answered');
          console.log(cf);
          this.call.startTime = moment.utc();
          this.phone_call.status = 'You are on a call with a customer';
          const form_data = {
            workspace_id: this.activeWorkspace._id,
            conversation_id: this.phone_call.conversation_id,
            msg_id: this.phone_call.msg_id,
            call_id: this.call_session.session.id,
            phone_number: this.phone_call.phone_number,
            call_type: this.call_session.session.direction,
            accepted_at: this.call.startTime,
            id: this.phone_call.id,
          };
          conversationsAPI.acceptedCall(form_data)
            .then(async (response) => {
              await popupErrorMessages(response);
              console.log('voip call charge');
            }).catch((err) => {
              console.log(err);
              this.soundIncomingCall.forEach((item) => {
                item.audio.pause();
                item.audio.currentTime = 0;
              });
              this.endCall({
                status: 'failed',
                cause: 'answer failed',
              });
              // this.handleEndPhoneCall();
            });

          this.call.talktime = window.setInterval(() => {
            const duration = moment().diff(moment(this.call.startTime), 'second');
            if (duration > 3600) {
              this.call.duration = moment.utc(duration * 1000).format('HH:mm:ss');
            } else {
              this.call.duration = moment.utc(duration * 1000).format('mm:ss');
            }
            if ((duration % 60) === 0) {
              console.log('voip call charge');
              const total_duration = duration / 60;
              conversationsAPI.creditCall({
                workspace_id: this.activeWorkspace._id,
                conversation_id: this.phone_call.conversation_id,
                id: this.phone_call.id,
                msg_id: this.phone_call.msg_id,
                call_id: this.call_session.session.id,
                total_duration,
              }).then((responsePing) => {
                if (!responsePing.error) {
                  this.successPingCall.push(total_duration);
                }
              });
            }
          }, 1000);
        });
        this.call_session.session.on('peerconnection', (peer) => {
          this.pc = peer.peerconnection;
          console.log('peerconnection after answer');
          console.log(this.pc);
          // Handle the audio track when received
          this.pc.ontrack = (event) => {
            console.log('WebRTC: Event ontrack: Received remote streams %d. Hooking up track ID: %s', event.streams.length, event.streams[0].id);
            const audio = document.querySelector('audio#audio');
            audio.srcObject = event.streams[0];
            event.streams[0].getTracks().forEach((track) => {
              if (track) {
                this.remoteStream.addTrack(track); // Add each track to the remote stream
              }
            });
            // const audioTrack = event.track;
            // const audioElement = this.$refs.audioPlayer;

            // // Attach the audio track to the HTML5 <audio> element
            // const mediaStream = new MediaStream([audioTrack]);
            // audioElement.srcObject = mediaStream;
          };

          //   this.pc.ontrack = (event) => {
          //     console.log('WebRTC: Event ontrack: Received remote streams %d. Hooking up track ID: %s', event.streams.length, event.streams[0].id);
          //     const audio = document.querySelector('audio#audio');
          //     audio.srcObject = event.streams[0];
          //     event.streams[0].getTracks().forEach((track) => {
          //       if (track) {
          //         this.remoteStream.addTrack(track); // Add each track to the remote stream
          //       }
          //     });
          //   };
          // }
        });
        this.call_session.session.on('ended', (end) => {
          console.log('rtc - ended');
          console.log(end);
          end.status = 'ended';
          this.endCall(end);
          // this.handleEndPhoneCall();
        });
        this.call_session.session.on('failed', (end) => {
          console.log('rtc - failed');
          console.log(end);
          end.status = 'failed';
          if (this.call_session.originator === 'remote') {
            this.soundIncomingCall.forEach((item) => {
              item.audio.pause();
              item.audio.currentTime = 0;
            });
          }
          this.endCall(end);
          // this.handleEndPhoneCall();
        });
      });
    } else if (this.ui_call_socket.button_call_active === true) {
      this.soundIncomingCall.forEach((item) => {
        item.audio.pause();
        item.audio.currentTime = 0;
      });
      this.SIPsocket.stop();
      this.ui_call_socket.button_call_active = false;
      console.log('disconnected socket sip navbar');
    }
    console.log('Navbar mounted');
    console.log(this.isEnableCallFeature);
    if (this.isEnableCallFeature && this.userProfile.agents && this.userProfile.agents[0]) {
      const agent_data = this.userProfile.agents[0];
      if (agent_data.assigned_call_feature === true && agent_data.is_available === true && agent_data.workspace_id === this.activeWorkspace._id) {
        this.doConnectSocket();
        socket_call.on('listen_call', async (data) => {
          const {
            message, session, call_action, action_by, call_type,
          } = data;

          // stop socket voip call
          if (this.ui_call_socket.button_call_active === true && this.isEnableVoIPFeature) {
            this.SIPsocket.stop();
          }
          console.log('--> incoming call', call_action, call_type);
          if (call_action === 'terminate') {
            this.soundIncomingCall.forEach((item) => {
              item.audio.pause();
              item.audio.currentTime = 0;
            });

            // start socket voip call
            if (this.ui_call_socket.button_call_active === false && this.isEnableVoIPFeature) {
              this.SIPsocket.start();
            }
            // check terminate just for the real agent when get socket terminate this.call.duration hide
            if (message.msg_id !== this.current_call_id) {
              return;
            }
            if (this.showModalMinimizeCall || this.showModalMaximizeCall) {
              await this.handleEndPhoneCall(false);
            }
            return;
          }
          if (call_action === 'ringing') {
            this.phone_call.status = 'Ringing';
            return;
          }
          if (call_action === 'accepted') {
            if (message.msg_id !== this.current_call_id) {
              return;
            }
            this.phone_call.status = 'Connected';
            this.call = {
              duration: 1,
              startCall: '',
            };
            this.call.startTime = moment.utc();
            this.call.talktime = setInterval(() => {
              if (this.call.startTime) {
                const now = moment.utc();
                const duration = moment.duration(now.diff(this.call.startTime, 'second'));
                if (duration > 3600) {
                  this.call.duration = moment.utc(duration * 1000).format('HH:mm:ss');
                } else {
                  this.call.duration = moment.utc(duration * 1000).format('mm:ss');
                }
                if ((duration % 60) === 0) {
                  const total_duration = duration / 60;
                  socket_call.emit('call-per-minute', { call_id: this.call_message_data.msg_id, total_duration });
                  conversationsAPI.pingCall({
                    call_id: this.call_message_data.msg_id,
                    total_duration,
                  }).then((responsePing) => {
                    if (!responsePing.error) {
                      this.successPingCall.push(total_duration);
                    }
                  });
                }
              }
            }, 1000);
            return;
          }
          if (call_action === 'rejected') {
            // await this.handleEndPhoneCall();
            this.soundIncomingCall.forEach((item) => {
              item.audio.pause();
              item.audio.currentTime = 0;
            });
            return;
          }
          if (call_action === 'media_update') {
            // console.log('this is media_update', JSON.stringify(session, null, 2));
            // await this.setupAudio(call_type);
            // await this.pc.setRemoteDescription(session);

            // await this.pc.setRemoteDescription(session);
            console.log('WebRTC: Setting remote description: ', call_action);
            // For the client create an answer
            // const answer = await this.pc.createAnswer();
            // console.log('LOCAL_ANSWER created: ', answer);
            // this.sdp_offer = session;
            // this.handleAnswerIncomingCall();
            return;
          }
          if (['accept', 'reject'].includes(call_action)) { // handle if agent accept or reject call
            if (message.msg_id !== this.current_call_id && this.call.duration) {
              return;
            }
            if (call_action === 'reject') {
              if (action_by === this.userProfile.id) {
                this.showModalMinimizeCall = false;
                this.soundIncomingCall.forEach((item) => {
                  item.audio.pause();
                  item.audio.currentTime = 0;
                });
              }
            }
            if (call_action === 'accept') {
              if (message && message.msg_id !== this.current_call_id) {
                this.call_message_data = {};
                this.handleEndPhoneCall();
              }
              this.phone_call.status = 'Connected';
            }
            return;
          }
          if (this.call.duration) { // receive socket but user still on another call, ignore
            return;
          }
          this.call_message_data = message;
          this.call_direction = session.sdp_type === 'answer' ? 'outgoing' : 'incoming';
          let devices;
          if (this.call_direction === 'incoming') {
            this.soundIncomingCall = [];
            devices = await navigator.mediaDevices.enumerateDevices();
            const audioSpeakersDevices = devices.filter((u) => u.kind === 'audiooutput');
            audioSpeakersDevices.forEach((device) => {
              this.soundIncomingCall.push({
                audio: new Audio(NotifIncomingCall),
                deviceId: device.deviceId,
                label: device.label,
              });
            });

            this.soundIncomingCall.map(async (item) => {
              await item.audio.setSinkId(item.deviceId);
              item.audio.loop = true;
              item.audio.volume = 0.7;
              item.audio.play();
            });
          }
          let selected_contact = {};
          if (this.call_direction === 'outgoing') {
            selected_contact = this.conversation?.contacts.find((v) => v.channel === 'whatsapp');
          }
          this.phone_call = {
            name: this.call_direction === 'outgoing' ? selected_contact.name : (message.contact.display_name || message.contact.name),
            phone_number: this.call_direction === 'outgoing' ? selected_contact.phone_number : message.contact.phone_number,
            status: session.sdp_type === 'answer' ? 'Ringing' : 'Incoming call...',
            originator: this.call_direction === 'outgoing' ? 'outgoing' : 'remote',
            mic: 'mdi mdi-microphone mdi-22px',
            video: call_type === 'video_call' ? 'mdi mdi-video mdi-22px' : 'mdi mdi-video-off mdi-22px',
            volume: 'mdi mdi-volume-low mdi-22px',
            channel: 'WhatsApp Call',
            conversation_id: '',
            msg_id: '',
            id: '',
          };
          this.call = {
            duration: 0,
            startTime: '',
            talktime: 0,
            startCall: '',
          };
          this.call_session = {
            originator: this.call_direction === 'outgoing' ? 'outgoing' : 'remote',
            call_type,
          };
          session.type = session.sdp_type;
          // this.sdp_offer = {
          //   sdp: session.sdp,
          //   type: session.type,
          // };
          this.sdp_offer = session;
          socket_call.emit('ws-conversation', `conversation:${this.activeWorkspace._id}:call:${this.call_message_data.msg_id}`);
          console.log(`conversation:${this.activeWorkspace._id}:call:${this.call_message_data.msg_id}`);
          if (this.call_direction === 'incoming') {
            await this.setupAudio(call_type);
            if (this.isEnableVideoCallFeature && call_type === 'video_call') {
              this.showModalMaximizeCall = true;
              this.phone_call.video = 'mdi mdi-video mdi-22px';
              this.isOffCam = false;
              const videoTracks = this.localStream.getVideoTracks();
              console.log('Found total %d Local Video Tracks', videoTracks.length);
              if (videoTracks.length > 0) {
                const prevMax = this.$refs.prevMaxCall;
                prevMax.showVideo = false;
                const focus_video = prevMax.$refs.focusVideo;
                focus_video.srcObject = this.localStream;
              }
            } else if (this.call_direction === 'incoming') {
              this.showModalMinimizeCall = true;
              this.phone_call.mic = 'mdi mdi-microphone mdi-22px';
              this.isPhoneMuted = false;
            }
          } else if (session.sdp_type === 'answer') {
            this.handleAnswerIncomingCall();
          }
        });
      }
      socket_call.on('disconnect', () => {
        this.reconnect = false;
        console.log('Disconnected from socket call, reconnecting...');
        // socket_call.connect();
      });
      socket_call.on('connect', () => {
        this.reconnect = true;
        console.log('connected to socket call navbar');
        socket_call.emit('conversation', agent_data.id);
        socket_call.emit('ws-conversation', `conversation:${this.activeWorkspace._id}:call`);
      });
    }
  },
  computed: {
    userProfile() {
      return this.$store.state.auth.userProfile || {};
    },
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace || {};
    },
    userAvatar() {
      return avatar(this.userProfile.name, this.userProfile.email);
    },
    activeNotification() {
      return this.$store.getters['notifications/activeNotification'] || {};
    },
    routeMeta() {
      return this.$route.meta;
    },
    workspaceBalance() {
      return this.$store.state.workspace.workspaceBalance?.toLocaleString('id-ID') || 0;
    },
    workspaceFreeQuota() {
      return this.$store.state.workspace.workspaceFreeQuota;
    },
    isAgent() {
      return this.userProfile?.agents ? !isEmpty(this.userProfile?.agents[0]) : false;
    },
    isEnableCallFeature() {
      if (this.activeWorkspace._id && this.activeWorkspace.products && this.userProfile.agents[0]?.workspace_id === this.activeWorkspace._id) {
        return this.activeWorkspace.products[0].pricing.whatsapp.enable_call_feature;
      }
      return false;
    },
    isEnableVideoCallFeature() {
      return this.activeWorkspace.products && this.activeWorkspace.products[0].pricing.whatsapp.enable_video_call_feature;
    },
    isEnableVoIPFeature() {
      if (this.$store.state.auth.sip?.access?.blocked !== true && this.activeWorkspace._id && this.activeWorkspace.products && this.userProfile.agents[0]?.workspace_id === this.activeWorkspace._id) {
        return this.$store.state.auth.sip?.access?.extension ? this.activeWorkspace.products[0].pricing.phone_call.enable_feature : false;
      }
      return false;
    },
    isUserEnableCall() {
      if (this.userProfile.agents?.length > 0) {
        const agent_data = this.userProfile.agents[0];
        return this.isEnableCallFeature && agent_data.assigned_call_feature === true && agent_data.is_available === true;
      }
      return false;
    },
    buttonCallActive() {
      return ui_call_socket.button_call_active;
    },
  },
  methods: {
    navigateNotification(notification) {
      let route;
      if (notification.type === 'notifications_blogs') {
        route = {
          name: 'Detail Notification Blogs',
          params: { id: notification._id },
        };
      } else if (notification.type === 'leads') {
        route = {
          name: 'LeadsCard',
          params: { id: notification.leads_board.id },
          hash: '#leads-comments',
        };
      }
      if (this.$route.name !== route.name || this.$route.params.id !== route.params.id) {
        // visit page and scroll
        this.$router.push(route).then(() => {
          if (route.hash) {
            const el = document.querySelector(route.hash);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }
        });
      } else if (route.hash) {
        // same page and scroll
        const el = document.querySelector(route.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    doConnectSocket() {
      if (!this.reconnect) {
        socket_call.disconnect();
      }
      socket_call.connect();
      // socket_call.emit('conversation', agent_data.id);
      // socket_call.emit('ws-conversation', `conversation:${agent_data.workspace_id}:call`);
      this.rtcSetupShared();
    },
    check_socket_sip(connect) {
      if (connect === '1') {
        this.connectedVoip = true;
        this.ui_call_socket.button_call_color = 'text-black';
        this.ui_call_socket.button_call_active = true;
        this.ui_call_socket.contact_call_color = 'outline-primary';
      } else {
        this.connectedVoip = false;
        this.ui_call_socket.button_call_color = 'text-secondary';
        this.ui_call_socket.button_call_active = false;
        this.ui_call_socket.contact_call_color = 'outline-black';
      }
    },
    async createSdpOffer(cb, call_type = 'call') {
      if (!this.pc) {
        await this.rtcSetupShared(call_type);
      }
      if (this.sdp_offer && this.sdp_offer.sdp) {
        this.$message({
          message: 'Failed. You are still on another call.',
          type: 'error',
        });
        return;
      }
      this.isConnecting = true;
      this.sdpOffer = '';
      // const offerOptions = {
      //   offerToReceiveAudio: 1,
      //   offerToReceiveVideo: this.isEnableVideoCallFeature && call_type === 'video_call' ? 1 : 0,
      //   voiceActivityDetection: false,
      // };
      await this.setupAudio(call_type);
      await this.configureCodecs(this.pc);
      this.pc.createOffer().then(async (offer) => {
        offer.sdp = this.modifyPayloadType(offer.sdp);
        offer.sdp = this.modifyHeaderExtensions(offer.sdp);
        this.sdpOffer = offer.sdp;
        await this.pc.setLocalDescription(offer);
        console.log('sdp offer local desc', this.pc.localDescription);
        cb(null, offer);
      }, (error) => console.log(`Failed to create session description: ${error.toString()}`));
    },
    async waitCallbackSdp(call_id, conversation, type = 'call') {
      socket_call.emit('ws-conversation', `conversation:${this.activeWorkspace._id}:call:${call_id}`);
      console.log(`conversation:${this.activeWorkspace._id}:call:${call_id}`);
      this.conversation = conversation;
      if (this.isEnableVideoCallFeature && type === 'video_call') {
        this.showModalMaximizeCall = true;
        this.phone_call.video = 'mdi mdi-video mdi-22px';
        this.isOffCam = false;
        const videoTracks = this.localStream.getVideoTracks();
        console.log('Found total %d Local Video Tracks', videoTracks.length);
        if (videoTracks.length > 0) {
          console.log(`Using Video device: ${videoTracks[0].label}`);
          const prevMax = this.$refs.prevMaxCall;
          prevMax.showVideo = false;
          const focus_video = prevMax.$refs.focusVideo;
          focus_video.srcObject = this.localStream;
        }
      } else {
        this.showModalMinimizeCall = true;
      }
      const selected_contact = this.conversation?.contacts.find((v) => v.channel === 'whatsapp');
      this.phone_call = {
        name: selected_contact.name,
        phone_number: selected_contact.phone_number,
        status: 'Connecting...',
        originator: 'outgoing',
        mic: 'mdi mdi-microphone mdi-22px',
        video: 'mdi mdi-video-off mdi-22px',
        volume: 'mdi mdi-volume-low mdi-22px',
        channel: 'WhatsApp Call',
        conversation_id: '',
        msg_id: '',
        id: '',
      };
      this.call = {
        duration: 0,
        startTime: '',
        talktime: 0,
        startCall: '',
      };
      this.call_session = {
        originator: 'outgoing',
        call_type: type,
      };
    },
    async setH264ToPayloadType97(sdp) {
      const lines = sdp.split(/\r\n|\r|\n/);
      const newLines = [];

      // --- SETUP ---
      // WhatsApp hardcoded requirements
      const TARGET_VIDEO_PT = '97';
      const TARGET_EXT_ROTATION = '3'; // urn:3gpp:video-orientation
      const TARGET_EXT_TRANSPORT = '4'; // transport-wide-cc-extensions-01

      let audioPts = [];
      const audioLine = lines.find((l) => l.startsWith('m=audio'));
      if (audioLine) {
        audioPts = audioLine.split(' ').slice(3);
      }

      // Find the local H264 Payload Type
      let h264Pt = null;
      lines.forEach((line) => {
        if (line.includes('profile-level-id=42001f') && line.includes('packetization-mode=1')) {
          const match = line.match(/a=fmtp:(\d+)/);
          if (match) h264Pt = match[1];
        }
      });

      if (!h264Pt) {
        console.warn('Standard H264 not found. Connection might fail.');
      }

      // --- REWRITE LOOP ---
      lines.forEach((line) => {
        // 1. FIX M=VIDEO LINE
        if (line.startsWith('m=video')) {
          const parts = line.split(' ');
          // Force only the target PT
          newLines.push(`${parts[0]} ${parts[1]} ${parts[2]} ${TARGET_VIDEO_PT}`);
          return;
        }

        // 2. FIX HEADER EXTENSIONS (EXTMAP)
        if (line.startsWith('a=extmap:')) {
          // A. Video Orientation -> Force ID 3
          if (line.includes('urn:3gpp:video-orientation')) {
            newLines.push(`a=extmap:${TARGET_EXT_ROTATION} urn:3gpp:video-orientation`);
            return;
          }
          // B. Transport Wide CC -> Force ID 4
          if (line.includes('transport-wide-cc-extensions-01')) {
            newLines.push(`a=extmap:${TARGET_EXT_TRANSPORT} http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01`);
            return;
          }

          // C. Remove colliding IDs (If existing line uses 3 or 4 but isn't the above, DROP IT)
          // This prevents 'a=extmap:3 abs-send-time' from existing alongside 'a=extmap:3 video-orientation'
          const idMatch = line.match(/^a=extmap:(\d+)/);
          if (idMatch && (idMatch[1] === TARGET_EXT_ROTATION || idMatch[1] === TARGET_EXT_TRANSPORT)) {
            return; // Drop colliding line
          }

          // D. Keep other extensions (like mid, abs-send-time) if they don't collide
          newLines.push(line);
          return;
        }

        // 3. FIX CODECS (RTPMAP, FMTP, RTCP-FB)
        const attrMatch = line.match(/^a=(rtpmap|fmtp|rtcp-fb):(\d+)/);
        if (attrMatch) {
          const pt = attrMatch[2];

          // Keep Audio
          if (audioPts.includes(pt)) {
            newLines.push(line);
            return;
          }

          // Rewrite H264 to 97
          if (pt === h264Pt) {
            const regex = new RegExp(`(^|:|\\s|=)${h264Pt}(\\s|\\r|\\n|$)`);
            newLines.push(line.replace(regex, `$1${TARGET_VIDEO_PT}$2`));
            return;
          }

          // Delete all other Video Codecs (VP8, RTX, etc)
          return;
        }

        // 4. PASS THROUGH EVERYTHING ELSE
        newLines.push(line);
      });

      return newLines.join('\r\n');
    },
    async specifyCodecPreferences() {
      const transceivers = this.pc.getTransceivers();
      const audioTransceiver = transceivers.find((t) => t.receiver.track?.kind === 'audio');
      const videoTransceiver = transceivers.find((t) => t.receiver.track?.kind === 'video');
      if (videoTransceiver) {
        const supportedCodecs = [];
        const videoCodecList = RTCRtpSender.getCapabilities('video')?.codecs || [];
        const selectedCodec = this.videoCodecs[0];
        if (selectedCodec) {
          videoCodecList.forEach((codec) => {
            if (codec.mimeType === selectedCodec.mimeType && (!selectedCodec.sdpFmtpLine || codec.sdpFmtpLine === selectedCodec.sdpFmtpLine)) {
              supportedCodecs.push(codec);
              console.debug(`[SDP] Selected codec: ${codec.mimeType} with params:${codec.sdpFmtpLine}`);
            }
          });
        }
        videoTransceiver.setCodecPreferences(supportedCodecs);
      }
      if (audioTransceiver) {
        const audioCodecList = RTCRtpSender.getCapabilities('audio')?.codecs ?? [];
        const allowedCodecs = audioCodecList ?? this.kAllowedAudioCodecs;
        if (audioCodecList) {
          console.debug(`[SDP] Overriding audio codecs to use: ${allowedCodecs}`);
        }
        const supportedCodecs = audioCodecList.filter((codec) => {
          const isSupported = allowedCodecs.includes(codec.mimeType);
          if (!isSupported) {
            console.debug(`[SDP] Excluding unsupported codec:${codec.mimeType}`);
          }
          return isSupported;
        });
        audioTransceiver.setCodecPreferences(supportedCodecs);
      }
    },
    async configureCodecs() {
      this.pc.getTransceivers().forEach((transceiver) => {
        if (transceiver.receiver.track?.kind === 'video') {
          transceiver.setCodecPreferences([
            {
              clockRate: 90000,
              mimeType: 'video/H264',
              sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42001f',
            },
          ]);
        } else if (transceiver.receiver.track?.kind === 'audio') {
          transceiver.setCodecPreferences([
            {
              channels: 2,
              clockRate: 48000,
              mimeType: 'audio/opus',
              sdpFmtpLine: 'minptime=10;useinbandfec=1',
            },
            {
              channels: 1,
              clockRate: 48000,
              mimeType: 'audio/telephone-event',
            },
          ]);
        }
      });

      this.pc.getSenders().forEach(async (sender) => {
        if (sender.track?.kind === 'video') {
          const params = sender.getParameters();
          if (!params.encodings) {
            params.encodings = [{}];
          }
          this.setVideoCodecParamaters(params);
          await sender.setParameters(params);
        } else if (sender.track?.kind === 'audio') {
          const params = sender.getParameters();
          if (!params.encodings) {
            params.encodings = [{}];
          }
          this.setAudioCodecParamaters(params);
          await sender.setParameters(params);
        }
      });
    },
    setVideoCodecParamaters(params) {
      params.encodings[0].codec = {
        clockRate: 90000,
        mimeType: 'video/H264',
        sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42001f',
      };
      return params;
    },
    setAudioCodecParamaters(params) {
      params.encodings[0].codec = {
        channels: 2,
        clockRate: 48000,
        mimeType: 'audio/opus',
        sdpFmtpLine: 'minptime=10;useinbandfec=1',
      };
      return params;
    },
    modifyPayloadType(srcOfferSdp) {
      if (!srcOfferSdp) {
        console.error('Offer SDP not found');
        return '';
      }
      let offerSdp = srcOfferSdp;
      const selectedCodec = {
        mimeType: 'video/H264',
        sdpFmtpLine: 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42001f',
        MapTo: 97,
      };
      const sdpLines = offerSdp.split('\r\n');
      let payloadType = null;
      /* eslint-disable no-plusplus */
      for (let i = 0; i < sdpLines.length; i++) {
        // Look for the video codec line
        if (sdpLines[i].startsWith('a=rtpmap:') && sdpLines[i].includes(selectedCodec.mimeType.split('/')[1])) {
          const pt = sdpLines[i].split(':')[1].split(' ')[0];
          const fmtpLine = sdpLines.find((line) => line.startsWith(`a=fmtp:${pt} `) && line.includes(selectedCodec.sdpFmtpLine));
          payloadType = pt;
          if (fmtpLine) {
            console.debug(`[SDP] Found payload type ${payloadType} for codec ${selectedCodec.mimeType}`);
            break;
          }
        }
      }
      if (payloadType) {
        const pattern = new RegExp(`rtcp-fb:${payloadType}`, 'g');
        offerSdp = offerSdp.replace(pattern, `rtcp-fb:${selectedCodec.MapTo}`);
        const pattern2 = new RegExp(`a=rtpmap:${payloadType}`, 'g');
        offerSdp = offerSdp.replace(pattern2, `a=rtpmap:${selectedCodec.MapTo}`);
        const pattern3 = new RegExp(`a=fmtp:${payloadType}`, 'g');
        offerSdp = offerSdp.replace(pattern3, `a=fmtp:${selectedCodec.MapTo}`);
        /* eslint-disable no-useless-escape */
        const videoLinePattern = /m=video .+ [A-Z\/]+ ([0-9]+)/;
        offerSdp = offerSdp.replace(videoLinePattern, (match, group1) => match.replace(group1, selectedCodec.MapTo.toString()));
        // Update the offer with modified SDP
        return offerSdp;
      }
      return offerSdp;
    },
    modifyHeaderExtensions(sdp) {
      const sdpLines = sdp.split('\r\n');
      const modifiedLines = [];
      console.log(sdpLines);
      sdpLines.forEach((line) => {
        if (line.startsWith('a=extmap:')) {
          if (line.includes('http://www.ietf.org/id/draft-holmer-rmcat-transport-wide-cc-extensions-01')) {
            const modifiedLine = line.replace(/a=extmap:\d+/, 'a=extmap:4');
            modifiedLines.push(modifiedLine);
            console.log(`[SDP] Modified transport-wide-cc extension: ${line} -> ${modifiedLine}`);
          } else {
            console.log(`[SDP] Removing extension: ${line}`);
          }
        } else {
          modifiedLines.push(line);
        }
      });
      const modifiedSdp = modifiedLines.join('\r\n');
      return modifiedSdp;
    },
    /* eslint-disable prefer-template */
    enforceCodecs(originalSdp) {
      const sdpLines = originalSdp.split('\r\n');
      const newSdpLines = [];
      let mLineAudio = '';
      let mLineVideo = '';
      const audioPayloadType = '111'; // Opus, based on your SDP analysis
      const videoPayloadType = '103'; // H264 (42001f, p-mode=1), based on your SDP analysis
      const videoRtxPayloadType = '104'; // RTX for 103
      sdpLines.forEach((line) => {
        if (line.startsWith('m=audio')) {
          mLineAudio = line;
        } else if (line.startsWith('m=video')) {
          mLineVideo = line;
        } else if (!line.startsWith('m=')) {
          newSdpLines.push(line);
        }
      });
      if (mLineAudio) {
        const mLineAudioParts = mLineAudio.split(' ').slice(0, 3);
        const newMLineAudio = mLineAudioParts.join(' ') + ' ' + audioPayloadType;
        newSdpLines.push(newMLineAudio);
      }
      if (mLineVideo) {
        const mLineVideoParts = mLineVideo.split(' ').slice(0, 3);
        const newMLineVideo = mLineVideoParts.join(' ') + ' ' + videoPayloadType + ' ' + videoRtxPayloadType;
        newSdpLines.push(newMLineVideo);
      }
      const finalLines = [];
      newSdpLines.forEach((line) => {
        if (line.startsWith('a=rtpmap:') || line.startsWith('a=fmtp:') || line.startsWith('a=rtcp-fb:')) {
          if (line.includes(`:${audioPayloadType}`) || line.includes(`:${videoPayloadType}`) || line.includes(`:${videoRtxPayloadType}`)) {
            finalLines.push(line);
          }
        } else {
          finalLines.push(line);
        }
      });
      const requiredH264Fmtp = 'level-asymmetry-allowed=1;packetization-mode=1;profile-level-id=42001f';
      const newH264FmtpLine = `a=fmtp:${videoPayloadType} ${requiredH264Fmtp}`;
      if (!finalLines.includes(newH264FmtpLine)) {
        finalLines.push(newH264FmtpLine);
      }
      finalLines.push('a=max-width:1280');
      finalLines.push('a=max-height:720');
      const headerLines = sdpLines.slice(0, 5);
      const finalSdp = headerLines.concat(finalLines.filter((line) => line.trim() !== '')).join('\r\n') + '\r\n';
      return finalSdp;
    },
    // async createOutgoingRing(form_data) {
    //   await conversationsAPI.outgoing(form_data)
    //     .then(async (response) => {
    //       await popupErrorMessages(response);
    //       // this.showModalMaximizeCall = true;
    //       this.showModalMinimizeCall = true;
    //       console.log(response);
    //     }).catch((err) => {
    //       console.log(err);
    //       this.handleEndPhoneCall();
    //     });
    // },
    setConnectedCall() {
      this.phone_call.phone_number = `62${this.call_session.session.remote_identity.uri.user}`;
      if (this.call_session.session.remote_identity.uri.user.startsWith('0')) {
        this.phone_call.phone_number = `62${this.call_session.session.remote_identity.uri.user.substring(1)}`;
      }
      if (this.call_session.session.remote_identity.uri.user.startsWith('+62')) {
        this.phone_call.phone_number = `62${this.call_session.session.remote_identity.uri.user.substring(3)}`;
      }
      const form_data = {
        workspace_id: this.activeWorkspace._id,
        call_id: this.call_session.session.id,
        phone_number: this.phone_call.phone_number,
        call_type: this.call_session.session.direction,
        calling_at: this.call.startCall,
      };
      conversationsAPI.connectedCall(form_data)
        .then(async (response) => {
          this.onSetConnected = false;
          await popupErrorMessages(response);
          if (form_data.call_type === 'incoming') {
            const get_contact = response.data.contact;
            this.phone_call.channel = 'Mobile Phone';
            this.phone_call.name = get_contact.name === get_contact.phone_number ? 'Unkwown Contact' : (get_contact.display_name || get_contact.name);
            this.phone_call.phone_number = get_contact.phone_number;
            this.phone_call.conversation_id = response.data.convo.id;
            this.phone_call.msg_id = response.data.msg_id;
            this.phone_call.id = response.data.calls.id;
            this.notes.msg_id = response.data.msg_id;
            this.phone_call.workspace_id = clone(this.activeWorkspace._id);
            // show incoming call
            this.phone_call.status = 'Incoming Call...';
            this.soundIncomingCall.forEach((item) => {
              item.audio.play();
            });
            this.showModalMinimizeCall = true;
          }
        }).catch((err) => {
          this.onSetConnected = false;
          console.log(err);
          this.soundIncomingCall.forEach((item) => {
            item.audio.pause();
            item.audio.currentTime = 0;
          });
          this.endCall({
            status: 'failed',
            cause: 'failed to connect call',
          });
          // this.handleEndPhoneCall();
        });
    },
    async handleAnswerIncomingCall() {
      const options = {
        // extraHeaders: ['X-Foo: foo', 'X-Bar: bar'],
        mediaConstraints: {
          audio: {
            noiseSuppression: true,
            echoCancellation: true,
            autoGainControl: true,
          },
          // audio: true,
          video: false,
        },
      };
      let type = '';
      this.soundIncomingCall.forEach((item) => {
        item.audio.pause();
        item.audio.currentTime = 0;
      });
      if (this.call_session.session) {
        this.call_session.session.answer(options);
        this.call_session.session.isOnHold = false;
        type = 'phone_call';
        // Handle the incoming media stream
      } else if (this.sdp_offer) {
        type = 'whatsapp';
        if (!this.pc) {
          await this.rtcSetupShared();
        }
        this.current_call_id = this.call_message_data.msg_id;
        this.notes.msg_id = this.call_message_data.msg_id;
        const session = this.sdp_offer;
        await this.setupAudio(this.call_session.call_type);
        await this.pc.setRemoteDescription((
          new RTCSessionDescription(session)
        ));
        if (this.call_session.call_type === 'video_call') {
          const senders = this.pc.getSenders();
          const videoSender = senders.find((sender) => sender.track && sender.track.kind === 'video');
          if (videoSender) {
            const parameters = videoSender.getParameters();
            const MAX_BITRATE_BPS = 750000;
            if (!parameters.encodings || parameters.encodings.length === 0) {
              parameters.encodings = [{}];
            }
            parameters.encodings[0].maxBitrate = MAX_BITRATE_BPS;
            videoSender.setParameters(parameters)
              .then(() => console.log('Video max bitrate successfully set to:', MAX_BITRATE_BPS))
              .catch((e) => console.error('Error setting bitrate parameters:', e));
          }
        }
        await this.specifyCodecPreferences();
        console.log('Signaling state:', this.pc.signalingState);
        // if (this.call_session.call_type === 'video_call') {
        //   this.startRecordingWithVideo();
        // } else {
        //   this.startRecording();
        // }
        if (this.call_session.call_type !== 'video_call') {
          this.startRecording();
        }
        if (this.call_session.call_type === 'video_call' && this.sdp_offer.type === 'answer') {
          return;
        }
        const answer = await this.pc.createAnswer();
        console.log('LOCAL_ANSWER created: ', answer);
        await this.pc.setLocalDescription(answer);
        this.showLoader();
        this.notes.content = '';
        const response = await conversationsAPI.callAction({
          workspace_id: this.activeWorkspace._id,
          conversation_id: this.call_message_data.conversation_id,
          action: 'accept',
          call_id: this.call_message_data.msg_id,
          sdp_answer: {
            sdp: answer.sdp,
            sdp_type: 'answer',
          },
          notes: this.notes.content,
        });
        this.hideLoader();
        console.log('response.error', response.error);
        if (response.error) { // reset call state
          return;
        }
        // if (this.sdp_offer.type === 'offer') {
        //   this.call = {
        //     duration: 0,
        //     startTime: moment.utc(),
        //   };
        // } else {
        //   return;
        // }
      }
      this.call.startTime = moment.utc();
      this.call.talktime = setInterval(() => {
        if (this.call.startTime) {
          const now = moment.utc();
          const duration = moment.duration(now.diff(this.call.startTime, 'second'));
          if (duration > 3600) {
            this.call.duration = moment.utc(duration * 1000).format('HH:mm:ss');
          } else {
            this.call.duration = moment.utc(duration * 1000).format('mm:ss');
          }
          if ((duration % 60) === 0 && type === 'whatsapp') {
            const total_duration = duration / 60;
            socket_call.emit('call-per-minute', { call_id: this.call_message_data.msg_id, total_duration });
            conversationsAPI.pingCall({
              call_id: this.call_message_data.msg_id,
              total_duration,
            }).then((responsePing) => {
              if (!responsePing.error) {
                this.successPingCall.push(total_duration);
              }
            });
          }
        }
      }, 1000);
    },
    async endCall(res) {
      this.phone_call.status = 'Ended';
      this.soundIncomingCall.forEach((item) => {
        item.audio.pause();
        item.audio.currentTime = 0;
      });
      if (!this.phone_call.conversation_id || !this.phone_call.msg_id || !this.phone_call.workspace_id) {
        this.handleEndPhoneCall();
        return;
      }
      const form_data = {
        call_id: this.call_session.session.id,
        phone_number: this.phone_call.phone_number,
        // workspace_id: this.activeWorkspace._id,
        workspace_id: this.phone_call.workspace_id,
        conversation_id: this.phone_call.conversation_id,
        status: res.status,
        reason: res.cause,
        time: {
          progress: this.call.startCall,
          handling: this.call.startTime,
          end: moment.utc(),
        },
        msg_id: this.phone_call.msg_id,
        id: this.phone_call.id,
        call_type: this.call_session.session.direction,
      };
      clearInterval(this.call.talktime);
      await conversationsAPI.endCall(form_data)
        .then(async (response) => {
          await popupErrorMessages(response);
          this.handleEndPhoneCall();
        }).catch((err) => {
          console.log(err);
          this.soundIncomingCall.forEach((item) => {
            item.audio.pause();
            item.audio.currentTime = 0;
          });
          this.handleEndPhoneCall();
        });
    },
    async handleEndPhoneCall(doCallAction = true) {
      console.log('Handler end call');
      this.soundIncomingCall.forEach((item) => {
        item.audio.pause();
        item.audio.currentTime = 0;
      });
      this.remoteStream = null;
      this.pc = null;
      await this.$store.dispatch('ui/clearActiveCall');
      if (this.call_message_data && this.call_message_data.msg_id) {
        // console.log(this.call_message_data.conversation_id, this.call_message_data.msg_id);
        if (doCallAction) {
          conversationsAPI.callAction({
            workspace_id: this.activeWorkspace._id,
            conversation_id: this.call_message_data.conversation_id,
            action: !this.call.duration && this.call_direction === 'incoming' ? 'reject' : 'terminate',
            call_id: this.call_message_data.msg_id,
            duration: this.call.duration,
            notes: this.notes.content,
          });
        }
      } else {
        console.log('terminate');
        if (this.SIPsocket) this.SIPsocket.terminateSessions();
      }
      if (this.localStream) {
        console.log('Reset local stream', this.sdp_offer);
        // && this.call_session.call_type !== 'video_call'
        if (this.mediaRecorder) {
          this.mediaRecorder.stop();
          this.isDrawing = false;
          this.animationFrameId = null;

          // Combine the chunks into a Blob after recording stops
          const { predefined_record_id } = this.sdp_offer;
          // console.log('predefined_record_id', predefined_record_id);
          this.mediaRecorder.onstop = () => {
            console.log('Recording stop');
            const audioBlob = new Blob(this.audioChunks, { type: 'video/webm;codecs=vp9,opus' });
            // const audioURL = URL.createObjectURL(audioBlob); // Create a URL for the recorded audio
            // Object.assign(document.createElement('a'), { href: audioURL, download: 'record.webm' }).click();
            this.audioChunks = [];
            console.log('Final Blob size:', audioBlob.size);
            const data = {
              workspace_id: this.activeWorkspace._id,
              predefined_record_id,
            };
            socket_call.emit('endOfStream', data);
          };
        }
        this.localStream.getTracks().forEach((track) => {
          console.log(`Stopping track: ${track.label} (ID: ${track.id}) to peer connection`);
          track.stop();
        });
      } else if (this.phone_call.phone_number !== '') {
        const constraints = {
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
          },
          video: false,
        };
        const local_stream = await navigator.mediaDevices.getUserMedia(constraints);
        local_stream.getTracks().forEach((track) => {
          console.log(`Stopping track: ${track.label} (ID: ${track.id}) to peer connection`);
          track.stop();
        });
      }
      this.current_call_id = null;
      this.localStream = null;
      this.sdp_offer = {};
      this.call_message_data = {};
      clearInterval(this.call.talktime);
      this.call_session = {};
      this.showModalIncomingCall = false;
      this.showModalMinimizeCall = false;
      this.showModalMaximizeCall = false;
      this.isPhoneMuted = false;
      this.isOffCam = true;
      this.call = {
        duration: 0,
        startTime: '',
        talktime: 0,
        startCall: '',
      };
      this.phone_call = {
        status: 'Calling...',
        mic: 'mdi mdi-microphone mdi-22px',
        video: 'mdi mdi-video-off mdi-22px',
        volume: 'mdi mdi-volume-low mdi-22px',
        name: '',
        channel: 'Mobile Phone',
        phone_number: '',
        conversation_id: '',
        workspace_id: '',
        msg_id: '',
        id: '',
      };
      this.notes = {
        showModalNotes: false,
        content: '',
        maximumLength: 4096,
        msg_id: '',
      };
    },
    async rtcSetupShared(call_type = '') {
      const servers = {
        iceServers: [
          {
            url: 'stun:stun.l.google.com:19302',
          },
        ],
        // iceCandidatePoolSize: 10,
        // iceTransportPolicy: 'all',
      };
      this.pc = new RTCPeerConnection(servers);
      console.log('WebRTC: Created RTCPeerConnection');
      this.connectedRtc = true;
      /**
       * Hooking up the RTCPeerConnection events
       */
      this.pc.onicegatheringstatechange = (ev) => {
        const connection = ev.target;

        console.log('WebRTC: Event onicegatheringstatechange:', connection.iceGatheringState);
      };

      this.pc.onicecandidate = async (event) => {
        console.log('WebRTC: Event onicecandidate:', event);
        if (event && event.candidate && (event.candidate.sdpMid || event.candidate.sdpMLineIndex)) {
          // Send ICE candidate to the remote peer via your signaling server
          console.log('New ICE candidate:', event.candidate);
          if (!this.pc.remoteDescription) {
            console.log('Remote description not set, skipping candidate');
            this.localIceCandidates.add(event.candidate);
            return;
          }
          console.log('Sending ICE candidate:', event.candidate);
          // this.localIceCandidates.add(event.candidate);
          try {
            await this.pc.addIceCandidate(new RTCIceCandidate(event.candidate));
            console.log('✓ Added remote ICE candidate');
          } catch (error) {
            console.error('Error adding ICE candidate:', error);
          }
        } else {
          console.log('✓ All ICE candidates sent');
          // ICE gathering is complete. The SDP is now ready.
          // This is where the final SDP is usually captured and sent.
          this.sdpOffer = this.pc.localDescription.sdp;
          this.isConnecting = false;
        }

        console.log('Updated LOCAL_DESCRIPTION:', this.pc ? this.pc.localDescription : null);
      };

      this.pc.onicecandidateerror = (event) => {
        console.log('WebRTC: Event onicecandidateerror:', event);
        if (this.notes.msg_id === '') {
          this.handleEndPhoneCall();
        } else {
          conversationsAPI.addNotes({
            workspace_id: this.activeWorkspace._id,
            msg_id: this.notes.msg_id,
            notes: this.notes.content,
          }).then(async (response) => {
            await popupErrorMessages(response);
          }).catch((err) => {
            console.log(err);
          });
        }
      };

      this.pc.onconnectionstatechange = async () => {
        console.log('WebRTC: Event onconnectionstatechange:', this.pc ? this.pc.connectionState : null);
        if (this.call_session.call_type === 'video_call' && this.sdp_offer.type === 'answer' && this.pc?.connectionState === 'complete') {
          const answer = await this.pc.createAnswer();
          console.log('LOCAL_ANSWER created: ', answer);
          await this.pc.setLocalDescription(answer);
          this.showLoader();
          const response = await conversationsAPI.callAction({
            workspace_id: this.activeWorkspace._id,
            conversation_id: this.call_message_data.conversation_id,
            action: 'accept',
            call_id: this.call_message_data.msg_id,
            sdp_answer: {
              sdp: answer.sdp,
              sdp_type: 'answer',
            },
            notes: this.notes.content,
          });
          this.notes.content = '';
          this.hideLoader();
          console.log('response.error', response.error);
        }
      };

      this.pc.oniceconnectionstatechange = (ev) => {
        console.log('WebRTC: Event oniceconnectionstatechange:', ev);
        console.log('ICE connection state:', this.pc.iceConnectionState);
        if (this.pc.iceConnectionState === 'disconnected' || this.pc.iceConnectionState === 'failed') {
          console.error('Connection lost or failed!');
        }
      };

      this.pc.onnegotiationneeded = (ev) => {
        console.log('WebRTC: Event onnegotiationneeded:', ev);
      };

      this.pc.onsignalingstatechange = (ev) => {
        console.log('WebRTC: Event onsignalingstatechange:', ev);
      };

      this.pc.ondatachannel = (ev) => {
        console.log('WebRTC: Event ondatachannel:', ev.channel);
      };

      this.pc.ontrack = (event) => {
        console.log('event.streams', event.streams, this.remoteStream);
        if (!this.remoteStream) {
          this.remoteStream = new MediaStream();
        }
        console.log('WebRTC: Event ontrack: Received remote streams %d. Hooking up track ID: %s', event.streams.length, event.streams[0].id);
        console.log('event.track.kindevent.track.kindevent.track.kind', event.track.kind);
        if (event.track.kind === 'audio') {
          const audio = document.querySelector('audio#audio');
          audio.srcObject = event.streams[0];
        }
        if (event.track.kind === 'video' && this.isEnableVideoCallFeature && (this.call_session?.call_type === 'video_call' || call_type === 'video_call')) {
          const prevMax = this.$refs.prevMaxCall;
          const prevMin = this.$refs.prevMinCall;
          if (prevMax) {
            // focus video
            const focus_video = prevMax.$refs.focusVideo;
            focus_video.srcObject = event.streams[0];
            // mini video
            const mini_video = prevMax.$refs.miniVideo;
            mini_video.srcObject = this.localStream;
            prevMax.showVideo = true;
          } else if (prevMin) {
            const mini_video = prevMin.$refs.miniVideo;
            mini_video.srcObject = event.streams[0];
            prevMin.showVideo = true;
          }
        }
        event.streams[0].getTracks().forEach((track) => {
          if (track) {
            this.remoteStream.addTrack(track); // Add each track to the remote stream
          }
        });
      };
    },
    startRecording() {
      console.log('start recording video call with audio only');
      const audioContext = new AudioContext();
      console.log('Set local source as audio context stream');
      const localSource = audioContext.createMediaStreamSource(this.localStream);
      console.log('Set remote source as audio context stream');
      const remoteSource = audioContext.createMediaStreamSource(this.remoteStream);
      const destination = audioContext.createMediaStreamDestination();
      localSource.connect(destination);
      remoteSource.connect(destination);
      this.mediaRecorder = new MediaRecorder(destination.stream);
      // Clear previous audio chunks
      this.audioChunks = [];
      let chunkIndex = 0;

      // On dataavailable, push the audio chunks to the array
      this.mediaRecorder.ondataavailable = (event) => {
        console.log('ondataavailable check');
        if (event.data.size > 0) {
          this.audioChunks.push(event.data);
          const uploadData = {
            workspace_id: this.activeWorkspace._id,
            predefined_record_id: this.sdp_offer.predefined_record_id,
            chunk: event.data, // Actual audio chunk
            chunkIndex,
          };
          socket_call.emit('uploadData', uploadData);
          chunkIndex += 1;
        }
      };

      // Start recording
      this.mediaRecorder.start(1000);
    },
    startRecordingWithVideo() {
      console.log('start recording video call with camera and audio');
      try {
        // Create video elements for drawing
        const canvas = document.createElement('canvas');
        canvas.width = 720;
        canvas.height = 1280;
        const ctx = canvas.getContext('2d');
        const localVideo = document.createElement('video');
        localVideo.srcObject = this.localStream;
        localVideo.play();
        localVideo.muted = true;
        localVideo.volume = 0;
        const remoteVideo = document.createElement('video');
        remoteVideo.srcObject = this.remoteStream;
        remoteVideo.play();
        const canvasStream = canvas.captureStream(30);
        // Draw remote video (full screen)
        this.isDrawing = true;
        const drawFrame = () => {
          if (!this.isDrawing) {
            console.log('Drawing stopped');
            return;
          }
          const remoteActive = this.remoteStream && this.remoteStream.getAudioTracks()[0]?.readyState === 'live';
          if (remoteActive) {
            ctx.drawImage(remoteVideo, 0, 0, canvas.width, canvas.height);
          } else {
            ctx.drawImage(remoteVideo, 0, 0, canvas.width, canvas.height);
            // Draw local video (picture-in-picture)
            const pipWidth = 320;
            const pipHeight = 240;
            const pipX = canvas.width - pipWidth - 20;
            const pipY = canvas.height - pipHeight - 20;
            // Draw border
            ctx.strokeStyle = 'white';
            ctx.lineWidth = 3;
            ctx.strokeRect(pipX, pipY, pipWidth, pipHeight);
            // Draw local video (mirrored)
            ctx.save();
            ctx.scale(-1, 1);
            ctx.drawImage(localVideo, -pipX - pipWidth, pipY, pipWidth, pipHeight);
            ctx.restore();
          }
          this.animationFrameId = requestAnimationFrame(drawFrame);
        };
        drawFrame();

        const audioContext = new AudioContext();
        const localSource = audioContext.createMediaStreamSource(this.localStream);
        const remoteSource = audioContext.createMediaStreamSource(this.remoteStream);
        const destination = audioContext.createMediaStreamDestination();
        localSource.connect(destination);
        // remoteSource.connect(destination);
        remoteSource.connect(audioContext.destination);

        const combinedStream = new MediaStream([
          ...canvasStream.getVideoTracks(),
          ...destination.stream.getAudioTracks(),
        ]);

        // check exist type
        const types = [
          'video/webm;codecs=vp9,opus',
          'video/webm;codecs=vp8,opus',
          'video/webm;codecs=h264,opus',
          'video/mp4;codecs=h264,aac',
          'video/webm',
        ];
        const supported = types.filter((type) => MediaRecorder.isTypeSupported(type));
        if (supported.length === 0) {
          supported.push('video/webm');
        }
        // until here
        this.mediaRecorder = new MediaRecorder(combinedStream, {
          mimeType: supported[0],
          videoBitsPerSecond: 2500000,
        });
        // Clear previous audio chunks
        this.audioChunks = [];
        let chunkIndex = 0;
        // On dataavailable, push the audio chunks to the array
        this.mediaRecorder.ondataavailable = (event) => {
          // console.log('Manual request, data size:', event.data.size);
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
            const uploadData = {
              workspace_id: this.activeWorkspace._id,
              predefined_record_id: this.sdp_offer.predefined_record_id,
              chunk: event.data, // Actual audio chunk
              chunkIndex,
            };
            socket_call.emit('uploadData', uploadData);
            chunkIndex += 1;
          }
        };

        // Start recording
        this.mediaRecorder.start(1000);
        console.log('Recording start');
      } catch (error) {
        console.error('Failed to start recording:', error);
      }
    },
    /**
     * Get the local Mic and add it to peer connection.
     */
    async setupAudio(call_type) {
      if (this.localStream) {
        return;
      }
      if (!this.pc) {
        await this.rtcSetupShared();
      }

      /**
       * Setup Media
       */
      let set_local_video = false;
      if (this.isEnableVideoCallFeature && call_type === 'video_call') {
        set_local_video = true;
      }
      this.localStream = await navigator.mediaDevices.getUserMedia({
        video: set_local_video,
        audio: {
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        },
      });
      const audioTracks = this.localStream.getAudioTracks();
      console.log('Found total %d Local Audio Tracks', audioTracks.length);
      if (audioTracks.length > 0) {
        console.log(`Using Audio device: ${audioTracks[0].label}`);
      }
      if (this.isEnableVideoCallFeature && call_type === 'video_call') {
        const videoTracks = this.localStream.getVideoTracks();
        console.log('Found total %d Local Video Tracks', videoTracks.length);
        if (videoTracks.length > 0) {
          console.log(`Using Video device: ${videoTracks[0].label}`);
          console.log('Video track:', videoTracks[0].readyState);
        }
      }

      this.localStream.getTracks().forEach((track) => {
        console.log(`Added track: ${track.label} (ID: ${track.id}) to peer connection`);
        this.pc.addTrack(track, this.localStream);
      });
    },
    handleMicPhoneCall() {
      this.isPhoneMuted = !this.isPhoneMuted;
      if (this.localStream) {
        this.localStream.getAudioTracks().forEach((track) => {
          track.enabled = !this.isPhoneMuted;
        });
        console.log('Microphone muted');
      } else if (this.call_session.session) {
        // Handle the audio track when received
        const localStream = this.pc.getLocalStreams()[0];
        localStream.getAudioTracks().forEach((track) => {
          track.enabled = !this.isPhoneMuted;
        });
        console.log('Microphone muted');
      }
      this.phone_call.mic = this.isPhoneMuted ? 'mdi mdi-microphone-off mdi-22px' : 'mdi mdi-microphone mdi-22px';
    },
    async handleCamPhoneCall() {
      this.isOffCam = !this.isOffCam;
      if (this.localStream && this.isEnableVideoCallFeature) {
        this.localStream = null;
        const call_type = this.isOffCam ? 'call' : 'video_call';
        let set_local_video = false;
        if (call_type === 'video_call') {
          set_local_video = true;
        }
        this.localStream = await navigator.mediaDevices.getUserMedia({
          video: set_local_video,
          audio: {
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
          },
        });
        const offerOptions = {
          offerToReceiveAudio: 1,
          offerToReceiveVideo: call_type === 'video_call' ? 1 : 0,
          voiceActivityDetection: false,
        };
        this.pc.createOffer(offerOptions).then(async (offer) => {
          this.sdp_offer = offer;
          this.pc.setLocalDescription(offer);
          this.phone_call.video = this.isOffCam ? 'mdi mdi-video-off mdi-22px' : 'mdi mdi-video mdi-22px';
          const response = await conversationsAPI.callAction({
            workspace_id: this.activeWorkspace._id,
            conversation_id: this.call_message_data.conversation_id,
            action: 'media_update',
            call_id: this.call_message_data.msg_id,
            sdp_answer: {
              sdp: offer.sdp,
              sdp_type: 'offer',
            },
          });
          console.log('response.error', response.error);
          if (response.error) {
            return;
          }
          // this.localStream.getVideoTracks().forEach((track) => {
          //   track.enabled = !this.isOffCam;
          // });
          const videoTracks = this.localStream.getVideoTracks();
          console.log('Found total %d Local Video Tracks', videoTracks.length);
          if (videoTracks.length > 0) {
            console.log(`Using Video device: ${videoTracks[0].label}`);
            const focus_video = this.$refs.prevMaxCall.$refs.focusVideo;
            focus_video.srcObject = this.localStream;
          }
          console.log('Camera off', this.isOffCam);
        }, (error) => console.log(`Failed to create session description: ${error.toString()}`));
      }
    },
    env(key) {
      return process.env[key];
    },
    handlerBtnSetAvailibility() {
      const message = `Set your availibility status to ${this.is_agent_availibility ? 'offline' : 'online'}?`;
      this.$confirm(message, this.$t('general.confirmation'), {
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        type: 'warning',
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const status_availability = this.is_agent_availibility ? 'off' : 'on';
            const response = await agents.setMyAgentStatus({
              status: status_availability,
            }).catch(() => {});
            await popupErrorMessages(response);
            this.is_agent_availibility = !this.is_agent_availibility;
            this.agent_availibility_color = this.is_agent_availibility ? 'success' : 'danger';
            await this.$store.dispatch('auth/updateUser');
            this.$message({
              message: 'Your availibility status has been changed',
              type: 'success',
            });
          }
          instance.confirmButtonLoading = false;
          cb();
        },
      }).catch(() => {});
    },
    async checkAvailibility() {
      const response = await agents.myAgentStatus();
      if (!response.error) {
        this.agent_availibility_color = isEmpty(response.data.agent_availibility.find((v) => v.is_available)) ? 'danger' : 'success';
        this.is_agent_availibility = !isEmpty(response.data.agent_availibility.find((v) => v.is_available));
      }
    },
    showLoader() {
      // if (this.loaderStack === 0) {
      //   this.loader = this.$loading.show();
      // }
      // this.loaderStack += 1;
      this.loaderStack = 1;
      this.loader = this.$loading.show();
    },
    hideLoader() {
      // this.loaderStack -= 1;
      // if (this.loaderStack === 0) {
      //   this.loader.hide();
      // }
      this.loaderStack = 0;
      this.loader.hide();
    },
    async getBusinessEntities() {
      const response = await profileApi.businessEntities();
      this.business_entities = response.data.rows;
    },
    async getBusinessTypes() {
      const response = await profileApi.businessTypes();
      this.business_types = response.data.rows;
    },
    async changePassword() {
      this.v$.form.$touch();
      if (this.v$.form.$error) return;
      this.loading.change_password = true;
      const response = await authApi.change_password({
        old_password: this.form.old_password,
        new_password: this.form.new_password,
        confirm_password: this.form.confirm_password,
      }).catch(() => {});
      this.loading.change_password = false;
      await popupErrorMessages(response);
      this.$message({
        type: this.$t('success'),
        message: this.$t('auth.success.change_password'),
      });
      this.showModal = false;
    },
    closeModal() {
      this.showModal = false;
      this.form = {};
    },
    selectWorkspace() {
      this.$store.dispatch('workspace/clearActiveWorkspace')
        .then(() => {
          this.$router.push('/workspaces');
        });
    },
    async doLogout() {
      const loader = this.$loading.show();
      await authApi.logout();
      loader.hide();
      this.$store.dispatch('auth/doLogout').then(() => {
        this.$router.push('/auth/login');
      });
    },
    async doShowModalCompanyProfile() {
      this.showLoader();
      this.showModalCompanyProfile = true;
      this.v$.company_form.$touch();
      await this.loadCompanyProfile();
      this.company_form = clone(this.companyProfile);
      await this.getBusinessEntities();
      await this.getBusinessTypes();
      this.hideLoader();
    },
    async loadCompanyProfile() {
      const response = await profileApi.companyProfile();
      this.companyProfile = response.data.profile;
    },
    async loadNotificationNews() {
      const open_date = cookie.get(`wappin-${this.userProfile.id}-notification`);
      let notificationData = [];
      if (this.activeWorkspace._id) {
        const response = await blogNotifApi.getNotificationNews(this.activeWorkspace._id, open_date);
        notificationData = response.data;
      }
      this.notificationList = notificationData;
    },
    handlingOpenNotification(data) {
      if (data.rows.length === 0) return;
      data.count_unread = 0;
      cookie.set(`wappin-${this.userProfile.id}-notification`, moment().toISOString(), {
        expires: 180, /* 180 days = 6 month */
      });
      this.loadNotificationNews();
    },
    async updateCompanyProfile() {
      this.v$.company_form.$touch();
      if (this.v$.company_form.$error) return;
      this.loading.update_compro = true;
      const formData = new FormData();
      formData.append('name', this.company_form.name);
      formData.append('brand_name', this.company_form.brand_name);
      formData.append('address', this.company_form.address);
      formData.append('business_entity_id', this.company_form.business_entity_id);
      formData.append('business_type_id', this.company_form.business_type_id);
      if (this.company_form.file) {
        formData.append('file', this.company_form.file);
      }
      const response = await profileApi.updateCompanyProfile({
        data: formData,
      });
      this.loading.update_compro = false;
      await popupErrorMessages(response);
      this.$store.dispatch('auth/updateCompanyProfile', response.data.profile);
      this.$message({
        type: this.$t('success'),
        message: this.$t('general.success'),
      });
      this.showModalCompanyProfile = false;
    },
    closeModalCompanyProfile() {
      this.showModalCompanyProfile = false;
    },
    async checkWorkspaceBalance() {
      if (this.activeWorkspace._id) {
        const response = await workspaceApi.check_balance({
          id: this.activeWorkspace._id,
        });
        await popupErrorMessages(response);
        this.$store.dispatch('workspace/setWorkspaceBalance', response.data);
      }
    },
    async doShowModalAccountProfile() {
      this.showLoader();
      this.showModalAccountProfile = true;
      this.v$.account_form.$touch();
      await this.loadAccountProfile();
      this.account_form = clone(this.accountProfile);
      this.hideLoader();
    },
    async loadAccountProfile() {
      const response = await profileApi.accountProfile();
      this.accountProfile = response.data.profile;
    },
    async updateAccountProfile() {
      this.v$.account_form.$touch();
      if (this.v$.account_form.$error) return;
      this.loading.update_accpro = true;
      const formData = new FormData();
      formData.append('name', this.account_form.name);
      formData.append('phone_number', this.account_form.phone_number);
      if (this.account_form.password) {
        formData.append('password', this.account_form.password);
      }
      formData.append('email', this.account_form.email);
      if (this.account_form.file) {
        formData.append('file', this.account_form.file);
      }
      const response = await profileApi.updateAccountProfile({
        data: formData,
      });
      this.loading.update_accpro = false;
      await popupErrorMessages(response);
      this.$store.dispatch('auth/updateAccountProfile', response.data.profile);
      this.$message({
        type: this.$t('success'),
        message: this.$t('general.success'),
      });
      this.showModalAccountProfile = false;
    },
    async uploadAttachment() {
      if (!this.account_form.file) {
        return;
      }
      this.loading.upload_file = true;
      const formData = new FormData();
      formData.append('file', this.account_form.file);
      const response = await profileApi.uploadAttachment({
        data: formData,
      }, (progressEvent) => {
        const p = parseInt((progressEvent.loaded / progressEvent.total) * 100, 0);
        this.upload_progress = p;
        if (p === 100) {
          this.upload_status = 'success';
        }
      });
      popupErrorMessages(response);
      if (this.account_form.attachment_ids) this.account_form.attachment_ids.push(response.data.attachment.id);
      else this.account_form.attachment_ids = [response.data.attachment.id];
      this.loading.upload_file = false;
    },
    closeModalAccountProfile() {
      this.showModalAccountProfile = false;
    },
    handlerChangeAmountBtn() {
      this.form1.amount = this.amount_opt.find((v) => v.text === this.form1.topup_amount).value;
      // console.log(value);
    },
    async handlerBtnNextTopup() {
      if (this.current_step === 0) {
        const pm = this.sof.find((v) => v.id === this.form1.payment_method_id);
        if (typeof this.form1.amount === 'string') {
          /* eslint-disable radix */
          this.form1.amount = parseInt(this.form1.amount);
        }
        await this.calculateTopup();
        this.confirmation_detail = {
          topup_amount: `Rp. ${this.calculate_topup_result.topup_amount.toLocaleString()}`,
          payment_method: pm.name,
          admin_fee: `Rp. ${this.calculate_topup_result.admin_fee.toLocaleString()}`,
          ppn_amount: this.calculate_topup_result.ppn_amount ? `Rp. ${this.calculate_topup_result.ppn_amount.toLocaleString()}` : '',
          total_transfer: `Rp. ${this.calculate_topup_result.grand_total.toLocaleString()}`,
        };
      } else if (this.current_step === 1) {
        await this.requestTopup();
      }
      if (this.current_step === 2) {
        this.showModalTopup = false;
        return;
      }
      this.current_step += 1;
    },
    async topupHistories() {
      this.loading.balance_histories = true;
      const { data } = await topupApi.topupHistories({
        id: this.activeWorkspace._id,
      });
      if (data.count) {
        this.topup_histories_list = data.rows.map((v) => {
          v.topup_date = moment(v.created_at).format('DD MMM YYYY');
          v.topup_amount_str = `Rp.${v.amount.toLocaleString()}`;
          v.tag_type = 'warning';
          if (v.status === 'paid') {
            v.tag_type = 'success';
          } else if (['expired', 'failed'].includes(v.status)) {
            v.tag_type = 'danger';
          } else if (v.status === 'cancelled') {
            v.tag_type = 'info';
          }
          return v;
        });
      }
      this.loading.balance_histories = false;
    },
    async requestTopup() {
      this.showLoader();
      try {
        const response = await topupApi.createRequest({
          id: this.activeWorkspace._id,
          data: {
            amount: this.form1.amount,
            payment_method_id: this.form1.payment_method_id,
          },
        });
        await popupErrorMessages(response);
        const { data: resp } = response;
        this.$message({
          message: this.$t('topup.success.create_request'),
          type: 'success',
        });
        this.resp = resp;
        this.resp.expired_at_str = moment(resp.expired_at).format('DD MMM YYYY, HH:mm');
      } catch (error) {
        this.current_step = 0;
        console.log(error);
      }
      this.hideLoader();
    },
    async handlerBtnTopup() {
      this.showLoader();
      try {
        const { data: resp_inquiry } = await topupApi.topupInquiryLastRequest({
          id: this.activeWorkspace._id,
        });
        console.log(resp_inquiry, isEmpty(resp_inquiry));
        if (!isEmpty(resp_inquiry)) {
          const {
            id, amount, admin_fee, total_transaction, virtual_account_number, expired_at, payment_method_detail,
            invoice_number, ppn_amount,
          } = resp_inquiry.current_request;
          this.confirmation_detail = {
            topup_amount: `Rp. ${amount.toLocaleString()}`,
            ppn_amount: ppn_amount ? `Rp. ${ppn_amount.toLocaleString()}` : '',
            payment_method: payment_method_detail.name,
            admin_fee: `Rp. ${admin_fee.toLocaleString()}`,
            total_transfer: `Rp. ${(total_transaction).toLocaleString()}`,
          };
          this.resp = {
            id,
            virtual_account_number,
            invoice_number,
            expired_at_str: moment(expired_at).format('DD MMM YYYY, HH:mm'),
            how_to_pay: payment_method_detail.how_to_pay,
          };
          this.is_waiting_payment = true;
          this.current_step = 2;
          this.hideLoader();
          this.showModalTopup = true;
          return;
        }
        this.showModalTopup = true;
        this.v$.form1.$touch();
        const { data } = await topupApi.paymentMethodList();
        this.sof = data.sof;
      } catch (error) {
        console.log(error);
        popupErrorMessages(error);
      }
      this.hideLoader();
    },
    onHideTopup() {
      this.form = {
        topup_amount: '',
        amount: null,
        payment_method_id: null,
      };
      this.confirmation_detail = {};
      this.resp = {
        how_to_pay: [],
      };
      this.current_step = 0;
      this.is_waiting_payment = false;
      this.showModalTopup = false;
    },
    handlerBtnCancelRequest() {
      this.$confirm(this.$t('topup.confirmation_cancel_request'), this.$t('general.confirmation'), {
        type: 'warning',
        confirmButtonText: this.$t('general.yes'),
        cancelButtonText: this.$t('general.no'),
        center: true,
        /* eslint-disable no-param-reassign */
        beforeClose: async (action, instance, cb) => {
          if (action === 'confirm') {
            // cb();
            // this.showLoader();
            instance.confirmButtonLoading = true;
            await topupApi.cancelRequest({
              id: this.activeWorkspace._id,
              topup_id: this.resp.id,
            }).then(async (response) => {
              await popupErrorMessages(response);
              this.$message({
                message: this.$t('topup.success.cancel_request'),
                type: 'success',
              });
              this.onHideTopup();
            });
            instance.confirmButtonLoading = false;
          }
          cb();
        },
      });
    },
    async calculateTopup() {
      const pm = this.sof.find((v) => v.id === this.form1.payment_method_id);
      const response = await topupApi.calculateTopup({
        workspace_id: this.activeWorkspace._id,
        data: {
          payment_method_id: pm.id,
          amount: this.form1.amount,
        },
      });
      this.calculate_topup_result = response.data;
    },
    async handlerBtnTopupDetail(item) {
      this.showLoader();
      this.showModalTopupDetail = true;
      await topupApi.detailRequest({
        id: this.activeWorkspace._id,
        topup_id: item.id,
      }).then(async (response) => {
        await popupErrorMessages(response);
        const { data } = response;
        data.result.topup_amount_str = `Rp.${data.result.amount.toLocaleString()}`;
        data.result.admin_fee_str = `Rp.${data.result.admin_fee.toLocaleString()}`;
        if (data.result.ppn_amount) data.result.ppn_amount_str = `Rp.${data.result.ppn_amount.toLocaleString()}`;
        data.result.total_transaction_str = `Rp.${data.result.total_transaction.toLocaleString()}`;
        data.result.payment_method_str = data.result.payment_method_detail.name;
        data.result.paid_at_str = data.result.status === 'paid' ? moment(data.result.paid_at).format('DD MMM YYYY, HH:mm') : '-';
        data.result.tag_type = 'warning';
        if (data.result.status === 'paid') {
          data.result.tag_type = 'success';
        } else if (['expired', 'failed'].includes(data.result.status)) {
          data.result.tag_type = 'danger';
        } else if (data.result.status === 'cancelled') {
          data.result.tag_type = 'info';
        }
        data.result.status_str = data.result.status.replace(/_/g, ' ').toUpperCase();
        data.result.expired_at_str = moment(data.result.expired_at).format('DD MMM YYYY, HH:mm');
        this.topup_history_detail = data.result;
      });
      this.hideLoader();
    },
    // handleStatusIncomingCall(status) {
    //   this.phone_call.status = status;
    // },
    // handleIncomingMaximizeCall(sess) {
    //   this.call_session = sess;
    //   this.showModalIncomingCall = true;
    //   this.showModalMinimizeCall = false;
    // },
    // handleIncomingMinimizeCall(sess) {
    //   this.call_session = sess;
    //   this.showModalMinimizeCall = true;
    //   this.showModalIncomingCall = false;
    // },
    handleMaximizePhoneCall() {
      this.showModalMaximizeCall = true;
      if (this.isEnableVideoCallFeature && this.call_session.call_type === 'video_call') {
        const prevMax = this.$refs.prevMaxCall;
        // focus video
        const focus_video = prevMax.$refs.focusVideo;
        focus_video.srcObject = this.remoteStream;
        // mini video
        const mini_video = prevMax.$refs.miniVideo;
        mini_video.srcObject = this.localStream;
        prevMax.showVideo = true;
      } else {
        const prevMin = this.$refs.prevMinCall;
        if (prevMin) {
          prevMin.showVideo = false;
        }
      }
      this.showModalMinimizeCall = false;
    },
    handleMinimizePhoneCall() {
      this.showModalMinimizeCall = true;
      const prevMin = this.$refs.prevMinCall;
      if (this.isEnableVideoCallFeature && this.call_session.call_type === 'video_call') {
        const mini_video = prevMin.$refs.miniVideo;
        mini_video.srcObject = this.remoteStream;
        prevMin.showVideo = true;
      } else {
        prevMin.showVideo = false;
      }
      this.showModalMaximizeCall = false;
    },
    showNumpad() {
      this.dialNumpad.showModalNumpad = !this.dialNumpad.showModalNumpad;

      this.dialNumpad.highlight = true;
      setTimeout(() => {
        this.dialNumpad.highlight = false;
      }, 500);
    },
    handleDial(item) {
      if (!item) return;

      if (item.toLowerCase() === 'remove') {
        if (isEmpty(this.dialNumpad.value)) {
          return;
        }

        let counter = 1;
        const result = this.dialNumpad.value.slice(0, this.dialNumpad.value.length - counter);
        this.dialNumpad.value = result;

        counter += 1;
        return;
      }

      this.dialNumpad.value += item;
    },
    async handleCall() {
      this.button_call_active = true;
      if (this.buttonCallActive) {
        this.$confirm(this.$t('conversations.confirm.phone_call'), this.$t('general.confirmation'), {
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.no'),
          type: 'warning',
          center: true,
          /* eslint-disable no-param-reassign */
          beforeClose: async (action, instance, cb) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true;
              conversationsAPI.numpadDirectCall({
                workspace_id: this.activeWorkspace._id,
                phone_number: this.dialNumpad.value,
              }).then(async (response) => {
                await popupErrorMessages(response);
                if (response.error) {
                  return;
                }
                this.dialNumpad.showModalNumpad = false;
                this.outgoingCall(response.data);
                this.$message({
                  message: 'Connecting to call',
                  type: 'success',
                });
              }).catch((err) => {
                console.log(err);
              });
              instance.confirmButtonLoading = false;
            }
            cb();
          },
        });
      }
    },
    onPasteNumpad(event) {
      event.preventDefault();
      const pasted = event.clipboardData.getData('text');
      const hasFiltered = pasted.replace(/[^0-9*#]/g, '');
      this.dialNumpad.value += hasFiltered;
    },
    onInputNumpad(event) {
      const allowedSymbol = /[0-9*#]/g;
      const input = event.target.value;
      const hasFiltered = input.match(allowedSymbol)?.join('') || '';
      this.dialNumpad.value = hasFiltered;
    },
    handleShowNotesModal() {
      this.notes.showModalNotes = !this.notes.showModalNotes;
    },
    saveNotes() {
      conversationsAPI.addNotes({
        workspace_id: this.activeWorkspace._id,
        msg_id: this.notes.msg_id,
        notes: this.notes.content,
      }).then(async (response) => {
        await popupErrorMessages(response);
        this.$message({
          message: 'Your notes has been saved',
          type: 'success',
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    formatDate(string, format = 'DD MMM YYYY, HH:mm:ss') {
      return string ? moment(string).format(format) : '-';
    },
    formatRelativeTime(date) {
      const now = moment();
      const diffMinutes = now.diff(moment(date), 'minutes');
      if (diffMinutes <= 5) {
        return moment(date).fromNow();
      }
      return moment(date).format('DD MMM YYYY HH:mm');
    },
    truncateHtmlPreserveTags(html, limit) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const { body } = doc;

      body.querySelectorAll('img, video').forEach((el) => el.remove());

      let charCount = 0;
      let reachedLimit = false;

      const walker = doc.createTreeWalker(body, NodeFilter.SHOW_ALL, null);
      let node = walker.nextNode();

      while (node) {
        const nextNode = walker.nextNode();

        if (reachedLimit) {
          if (node.parentNode) node.parentNode.removeChild(node);
        } else if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent || '';
          // text = text.replace(/\s+/g, ' ');

          const remaining = limit - charCount;

          if (text.length > remaining) {
            node.textContent = `${text.slice(0, remaining)}…`;
            charCount = limit;
            reachedLimit = true;

            let { nextSibling } = node;
            while (nextSibling) {
              const next_node = nextSibling.nextSibling;
              nextSibling.remove();
              nextSibling = next_node;
            }

            let parent = node.parentNode;
            while (parent && parent.parentNode) {
              let parentNext = parent.nextSibling;
              while (parentNext) {
                const next_node = parentNext.nextSibling;
                parentNext.remove();
                parentNext = next_node;
              }
              parent = parent.parentNode;
            }
          } else {
            charCount += text.length;
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const tag = node.tagName.toLowerCase();
          if (tag === 'br' || tag === 'li') {
            charCount += 1;
            if (charCount > limit) {
              if (node.parentNode) node.parentNode.removeChild(node);
              reachedLimit = true;
            }
          }
        }

        node = nextNode;
      }
      /** Delete elements after reach 100 */
      body.querySelectorAll('p, span, div, a, li, ul, ol, br').forEach((el) => {
        if (!el.textContent.trim()) el.remove();
      });

      return body.innerHTML;
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar .navbar-content {
  @media screen and (max-width: 991px) {
    width: calc(100% - 100px);
  }
  // @media screen and (max-width: 425px) {
  //   p {
  //     visibility: hidden;
  //   }
  // }
}
</style>
